import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';


import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    IconButton,
    Button,
    Typography,
    Select,
    MenuItem,
    FormControl,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    Slide,
    Tooltip
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon,
    Close as CloseIcon,
    AccountBalance as AccountBalanceIcon,
    Storefront,
    Description,
    ReceiptLong
} from '@mui/icons-material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import axios from '../../../axios-order';
import BusinessIcon from '@mui/icons-material/Business';
import {
    Container,
    Grid
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import SelectInput from "../../../components/ui/basicSelectInput";
import InputField from "../../../components/ui/inputField";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoadingButton } from '@mui/lab';
import ValidatedDatePicker from "../../../components/ui/DatePicker";
import { Autocomplete } from "@mui/material";
import StorageIcon from '@mui/icons-material/Storage';
import { NoDataOverlay, NoResultsOverlay } from '../common';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ClearIcon from '@mui/icons-material/Clear';
import moment from "moment";
import CancelIcon from '@mui/icons-material/Cancel';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadIcon from '@mui/icons-material/Download';
import Template from '../TaxInvoice/template';

const stateOptions = [
    { id: 1, state: "Jammu & Kashmir", gstCode: "01" },
    { id: 2, state: "Himachal Pradesh", gstCode: "02" },
    { id: 3, state: "Punjab", gstCode: "03" },
    { id: 4, state: "Chandigarh", gstCode: "04" },
    { id: 5, state: "Uttarakhand", gstCode: "05" },
    { id: 6, state: "Haryana", gstCode: "06" },
    { id: 7, state: "Delhi", gstCode: "07" },
    { id: 8, state: "Rajasthan", gstCode: "08" },
    { id: 9, state: "Uttar Pradesh", gstCode: "09" },
    { id: 10, state: "Bihar", gstCode: "10" },
    { id: 11, state: "Sikkim", gstCode: "11" },
    { id: 12, state: "Arunachal Pradesh", gstCode: "12" },
    { id: 13, state: "Nagaland", gstCode: "13" },
    { id: 14, state: "Manipur", gstCode: "14" },
    { id: 15, state: "Mizoram", gstCode: "15" },
    { id: 16, state: "Tripura", gstCode: "16" },
    { id: 17, state: "Meghalaya", gstCode: "17" },
    { id: 18, state: "Assam", gstCode: "18" },
    { id: 19, state: "WestBengal", gstCode: "19" },
    { id: 20, state: "Jharkhand", gstCode: "20" },
    { id: 21, state: "Odisha", gstCode: "21" },
    { id: 22, state: "Chhattisgarh", gstCode: "22" },
    { id: 23, state: "Madhya Pradesh", gstCode: "23" },
    { id: 24, state: "Gujarat", gstCode: "24" },
    { id: 25, state: "Daman & Diu", gstCode: "25" },
    { id: 26, state: "Dadra & NagarHaveli", gstCode: "26" },
    { id: 27, state: "Maharashtra", gstCode: "27" },
    { id: 28, state: "Karnataka", gstCode: "29" },
    { id: 29, state: "Goa", gstCode: "30" },
    { id: 30, state: "Lakshdweep", gstCode: "31" },
    { id: 31, state: "Kerala", gstCode: "32" },
    { id: 32, state: "Tamil Nadu", gstCode: "33" },
    { id: 33, state: "Puducherry", gstCode: "34" },
    { id: 34, state: "Andaman & NicobarIslands", gstCode: "35" },
    { id: 35, state: "Telangana", gstCode: "36" },
    { id: 36, state: "Andhra Pradesh", gstCode: "37" },
    { id: 37, state: "Ladakh", gstCode: "38" },
    { id: 38, state: "Other Territory", gstCode: "97" },
    { id: 39, state: "Other Country", gstCode: "99" },
];


const categoryOptions = [
    { id: "B2B", category: "B2B" },
    { id: "B2C", category: "B2C" },
    { id: "SEZWP", category: "SEZWP" },
    { id: "SEZWOP", category: "SEZWOP" },
    { id: "EXPWP", category: "EXPWP" },
    { id: "EXPWOP", category: "EXPWOP" },
    { id: "DEXP", category: "DEXP" },
]

const purchaseCategoryOptions = [
    { id: "B2B", category: "B2B" },
    { id: "B2C", category: "B2C" },
    { id: "IMPG", category: "IMPG" },
    { id: "IMPG SEZ", category: "IMPG SEZ" },

]

const transactionTypeOptions = [
    { id: 1, transaction_type: "Regular" },
    { id: 2, transaction_type: "Bill From - Dispatch From" },
    { id: 3, transaction_type: "Bill To - Ship To" },
    { id: 4, transaction_type: "Combination 2 & 3" },
]

const documentTypesSales = [
    { id: 1, document_type: "Invoice" },
    { id: 2, document_type: "Credit Note" },
    { id: 3, document_type: "Debit Note" }
]

const documentTypesPurchase = [
    { id: 1, document_type: "Bill" },
    { id: 2, document_type: "Credit Note" },
    { id: 3, document_type: "Debit Note" }
]


const Taxinvoice = () => {

    const [taxInvoiceFormData, setTaxInvoiceFormData] = useState({
        invoice_type: '',
        voucher_type: '',
        category: '',
        legal_name: '',
        gstin: '',
        erp_code: '',
        reverse_charge: 'No',
        address_1: '',
        address_2: '',
        document_type: '',
        location: '',
        state: '',
        document_prefix: '',
        document_suffix: '',
        document_number: '',
        service_name: '',
        picode: '',
        email: '',
        document_date: '',
        original_invoice_date: '',
        original_invoice_no: '',
        phone_no: '',
        pos: '',
        igst_on_intra: 'No',
        transaction_type: 'Regular',
        recipeint_id: '',
        dispatch_gstin: '',
        dispatch_legal_name: '',
        dispatch_location: '',
        dispatch_pincode: '',
        dispatch_address_1: '',
        dispatch_address_2: '',
        dispatch_state: '',
        ship_gstin: '',
        ship_legal_name: '',
        ship_location: '',
        ship_pincode: '',
        ship_address_1: '',
        ship_address_2: '',
        ship_state: '',
        tax_invoice_line_items: [],
        other_charges: '',
        discount: '',
        round_off: '',
        grand_total: '',
        common_tax_invoice_id: ''
    })

    const [taxInvoiceLineItemFormData, setTaxInvoiceLineItemFormData] = useState({
        sr_no: '',
        product_id: '',
        product_description: '',
        is_service: '',
        hsn_sac_code: '',
        unit: '',
        quantity: '',
        unit_price: '',
        free_quantity: '',
        gross_amount: '',
        discount: '',
        taxbale_value: '',
        gst_rate: '',
        sgst_value: '',
        cgst_value: '',
        igst_value: '',
        cess_rate: '',
        cess_ad_value: '',
        cess_non_ad_value: '',
        state_cess_rate: '',
        state_cess_value: '',
        state_cess_non_ad_value: '',
        other_charges: '',
        total_item_amount: ''
    })

    const [masterId, setMasterId] = useState([])
    const [taxInvoiceData, setTaxInvoiceData] = useState([])
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [productDataLoading, setProductDataLoadingLoading] = useState(false)
    const [productFormDialogOpen, setProductDailogOpen] = useState(false)
    const [selectedTaxInvoice, setSelectedTaxInvoice] = useState({})
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
    const [openTaxInvoiceForm, setTaxInvoiceForm] = useState(false)
    const [submitted, setSubmitted] = useState(false);
    const [gstinOptions, setGstinOptions] = useState([])
    const [serviceData, setServiceData] = useState([])
    const [openAddressDialog, setOpenAddressDialog] = useState(false);
    const [openTaxInvoiceLineItemDailog, setTaxInvoiceLineItemDailog] = useState(false)
    const [taxInvoiceLineAction, setTaxInvoiceLineAction] = useState('')
    const [dispatchFromOptions, setDispatchFromOptions] = useState([])
    const [billToOptions, setBillToOptions] = useState([])
    const [productData, setProductData] = useState([])
    const [taxInvoiceDailogKey, setTaxInvoiceDailogKey] = useState('')
    const [showTemplate, setShowTemplate] = useState(false);
    const [showSlide, setShowSlide] = useState(false);
    const [invoiceDataForTemplate, setInvoiceDataForTemplate] = useState(null);
    const containerRef = useRef(null);
    const history = useHistory();
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showDiscardDialog, setShowDiscardDialog] = useState(false);
    const [pendingClose, setPendingClose] = useState(false);
    const [initialFormData, setInitialFormData] = useState(null);
    const [pendingTaxInvoiceDailogKey, setPendingTaxInvoiceDailogKey] = useState('');
    // Add this useEffect to track form changes
    useEffect(() => {
        // Only track changes when form is open and not in view mode
        if (openTaxInvoiceForm && taxInvoiceDailogKey !== "view") {
            // If initialFormData is not set, this is the first render - store initial state
            if (initialFormData === null) {
                setInitialFormData(JSON.stringify(taxInvoiceFormData));
                setHasUnsavedChanges(false);
            } else {
                // Compare current form data with initial form data
                const currentData = JSON.stringify(taxInvoiceFormData);
                const hasChanged = currentData !== initialFormData;
                setHasUnsavedChanges(hasChanged);
            }
        }
    }, [taxInvoiceFormData, openTaxInvoiceForm, taxInvoiceDailogKey]);

    useEffect(() => {
        if (!openTaxInvoiceForm) {
            setInitialFormData(null);
            setHasUnsavedChanges(false);
        }
    }, [openTaxInvoiceForm]);

    // Add this function to handle close attempts
    const handleAttemptClose = () => {
        if (hasUnsavedChanges && taxInvoiceDailogKey !== "view") {
            setShowDiscardDialog(true);
            setPendingClose(true);
        } else {
            handleConfirmClose();
        }
    };

    // Add this function to handle confirmed close
    const handleConfirmClose = () => {
        setHasUnsavedChanges(false);
        setShowDiscardDialog(false);

        // ✅ Use pendingTaxInvoiceDailogKey instead of taxInvoiceDailogKey
        if (pendingClose && pendingTaxInvoiceDailogKey) {
            // Clear current form
            clearTaxInvoiceForm();
            clearTaxInvoiceLineItemData();

            // ✅ If it's "add" mode, just open fresh form
            if (pendingTaxInvoiceDailogKey === "add") {
                setTaxInvoiceDailogKey("add");
                setTaxInvoiceForm(true);
                setInitialFormData(null);
            }
            // If it's view or edit mode, load the selected record data
            else if ((pendingTaxInvoiceDailogKey === "view" || pendingTaxInvoiceDailogKey === "edit") && selectedTaxInvoice && Object.keys(selectedTaxInvoice).length > 0) {
                const record = selectedTaxInvoice;
                setTaxInvoiceDailogKey(pendingTaxInvoiceDailogKey);
                setTaxInvoiceFormData({
                    invoice_type: record.invoice_type,
                    voucher_type: record.voucher_type,
                    category: record.inv_det_category,
                    legal_name: record.inv_det_legal_name,
                    gstin: record.inv_det_gstin,
                    reverse_charge: record.inv_det_reverse_charge,
                    address_1: record.inv_det_address_one,
                    address_2: record.inv_det_address_two,
                    document_type: record.inv_det_document_type,
                    location: record.inv_det_location,
                    state: record.inv_det_state,
                    document_prefix: record.document_prefix,
                    document_suffix: '',
                    document_number: record.inv_det_document_number,
                    service_name: record.service,
                    picode: record.inv_det_pincode,
                    email: record.inv_det_email,
                    document_date: record.inv_det_document_date,
                    original_invoice_date: record.original_invoice_date,
                    original_invoice_no: record.original_invoice_number,
                    phone_no: record.inv_det_phone_number,
                    pos: record.place_of_supply,
                    igst_on_intra: record.inv_det_igst_on_intra,
                    transaction_type: record.inv_det_transaction_type,
                    recipeint_id: '',
                    dispatch_gstin: '',
                    dispatch_legal_name: record.dispatch_det_legal_name,
                    dispatch_location: record.dispatch_det_location,
                    dispatch_pincode: record.dispatch_det_pin_code,
                    dispatch_address_1: record.dispatch_det_address_one,
                    dispatch_address_2: record.dispatch_det_address_two,
                    dispatch_state: record.dispatch_det_state,
                    ship_gstin: record.ship_gstin,
                    ship_legal_name: record.shipping_det_legal_name,
                    ship_location: record.shipping_det_location,
                    ship_pincode: record.shipping_det_pin_code,
                    ship_address_1: record.shipping_det_address_one,
                    ship_address_2: record.shipping_det_address_two,
                    ship_state: record.shipping_det_state,
                    tax_invoice_line_items: record.products,
                    discount: record.overall_discount,
                    round_off: record.overall_round_off,
                    grand_total: record.amount_det_total_item_amount,
                    other_charges: record.other_charges,
                    common_tax_invoice_id: record.common_tax_invoice_id
                });

                setTaxInvoiceForm(true);
                setInitialFormData(null);
            }
        } else {
            // Original behavior - just close
            setTaxInvoiceForm(false);
            clearTaxInvoiceForm();
            clearTaxInvoiceLineItemData();
        }

        setPendingClose(false);
        setPendingTaxInvoiceDailogKey(''); // ✅ Clear pending key
    };

    // Add this function to cancel close
    const handleCancelClose = () => {
        setShowDiscardDialog(false);
        setPendingClose(false);
        setPendingTaxInvoiceDailogKey('');
    };




    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
        // setSnackbarOpen(false);
    };


    // Function to close Snackbar
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");

    };

    const downloadInvoice = (id) => {
        const business_entity_id = localStorage.getItem('business_entity_id');
        const url = `/einvoice/download_generated_einvoice/${business_entity_id}/${id}`;

        axios.get(url, { responseType: 'json' })
            .then(response => {
                if (response?.data?.status && response?.data?.file) {
                    const base64Data = response.data.file;
                    try {
                        const byteCharacters = atob(base64Data);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: 'application/zip' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = 'invoice.zip';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } catch (err) {
                        console.error('Base64 decoding failed:', err);
                    }
                } else {
                    handleSnackbarOpen(response?.data?.message || 'File not found.', 'warning');
                }
            })
            .catch(error => {
                console.error('Error downloading zip file:', error);
            });
    };

    const downloadInvoicetax = (row) => {
        const business_entity_id = localStorage.getItem('business_entity_id');
        const apiUrl = `/einvoice/export_normal_invoice/${business_entity_id}/${row.id}`;

        console.log('1. Fetching data for row:', row);

        axios.get(apiUrl)
            .then(response => {
                console.log('2. API Response:', response.data);

                if (response?.data) {
                    const apiData = response.data;
                    console.log('3. Setting invoice data:', apiData);

                    setInvoiceDataForTemplate(apiData);
                    setShowTemplate(true);
                } else {
                    handleSnackbarOpen('Data not found.', 'warning');
                }
            })
            .catch(error => {
                console.error('4. Error:', error);
                handleSnackbarOpen('Error while fetching invoice data.', 'error');
            });
    };


    // const downloadInvoicetax = (id) => {
    //     const business_entity_id = localStorage.getItem('business_entity_id');
    //     const apiUrl = `/einvoice/export_normal_invoice/${business_entity_id}/${id}`;

    //     axios.get(apiUrl)
    //         .then(response => {
    //             if (response?.data?.status && response?.data?.file) {
    //                 const fileContent = response.data.file;
    //                 try {
    //                     const byteCharacters = atob(fileContent);
    //                     const byteNumbers = new Array(byteCharacters.length);
    //                     for (let i = 0; i < byteCharacters.length; i++) {
    //                         byteNumbers[i] = byteCharacters.charCodeAt(i);
    //                     }
    //                     const byteArray = new Uint8Array(byteNumbers);
    //                     const htmlContent = new TextDecoder().decode(byteArray);

    //                     const iframe = document.createElement('iframe');
    //                     iframe.style.position = 'absolute';
    //                     iframe.style.width = '0';
    //                     iframe.style.height = '0';
    //                     iframe.style.border = 'none';
    //                     iframe.style.visibility = 'hidden';
    //                     document.body.appendChild(iframe);

    //                     iframe.onload = () => {
    //                         iframe.contentWindow.focus();
    //                         iframe.contentWindow.print();
    //                         setTimeout(() => iframe.remove(), 1000);
    //                     };

    //                     const iframeDoc = iframe.contentWindow.document;
    //                     iframeDoc.open();
    //                     iframeDoc.write(htmlContent);
    //                     iframeDoc.close();
    //                 } catch (err) {
    //                     console.error('Error decoding or printing file:', err);
    //                 }
    //             } else {
    //                 handleSnackbarOpen(response?.data?.message || 'File not found.', 'warning');
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Error while downloading file:', error);
    //         });
    // };



const handleEWayBill = (row) => {
    if (hasUnsavedChanges && openTaxInvoiceForm && (taxInvoiceDailogKey === "add" || taxInvoiceDailogKey === "edit")) {
        setShowDiscardDialog(true);
        setPendingClose(false);
        return;
    }
    history.push({
        pathname: `/eway-bill/${row.id}`,
        state: { 
            tax_master_id: row.id,
            document_number: row.inv_det_document_number
        }
    });
}

    const columns = [
        {
            field: 'inv_det_gstin',
            headerName: 'GSTIN',
            flex: 1, // Allows it to take available space
            minWidth: 150, // Minimum width
            align: 'left',
            filterable: true,
        },
        {
            field: 'inv_det_legal_name',
            headerName: 'Legal Name',
            flex: 1, // Makes it flexible
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'inv_det_document_type',
            headerName: 'Document Type',
            flex: 0.7, // Adjust the flex to be a smaller width
            minWidth: 180, // Minimum width to prevent squishing
            pinned: 'left',
            align: 'left',
            filterable: true,
        },
        {
            field: 'inv_det_document_number',
            headerName: 'Document Number',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
        },
        {
            field: 'inv_det_document_date',
            headerName: 'Document Date',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        {
            field: 'grand_total',
            headerName: 'Total Amount',
            flex: 1, // Flexible
            minWidth: 180,
            align: 'left',
            filterable: true,
            valueGetter: (params) => {
                const grandTotal = params.row.grand_total;
                const fallback = params.row.amount_det_total_item_amount;
                return grandTotal != null ? grandTotal : fallback;
            },
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1, // Makes it flexible
            minWidth: 260, // Minimum width to prevent squishing
            align: 'left',
            renderCell: (params) => {
                const row = params.row;

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>

                        <IconButton
                            size="medium"
                            onClick={() => handleOpenTaxInvoiceDailog("view", row)}
                            title="View Tax Invoice"
                        >
                            <VisibilityIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>


                        <Tooltip
                            title={row.einvoice_status === "Generated" || row.disable ? "Tax invoice is already generated or cancelled" : ""}
                        >
                            <span>
                                <IconButton
                                    size="medium"
                                    onClick={() => handleOpenTaxInvoiceDailog("edit", row)}
                                    title="Edit Tax Invoice"
                                    disabled={row.einvoice_status === "Generated" || row.disable}
                                    sx={{ "&.Mui-disabled": { cursor: "not-allowed" } }}
                                >
                                    <EditIcon fontSize="medium" style={{ color: "#455a64" }} />
                                </IconButton>

                            </span>
                        </Tooltip>

                        <IconButton
                            size="medium"
                            onClick={() => {
                                templateSlide(row)

                            }}
                            title="Preview Template"
                        >
                            <Description fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        {/* <IconButton
                            size="medium"
                            onClick={() => templateSlide(row)}
                            title="Preview Template"
                        >
                            <Description fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton> */}

                        {/* <IconButton
                            size="medium"
                            disabled={row.einvoice_status === "Generated"}
                            title="Download Tax Invoice"
                            onClick={() =>
                                row.inv_det_document_type === 'E-Invoice'
                                    ? downloadInvoice(row.id)
                                    : downloadInvoicetax(row.id)
                            }
                        >
                            <FileDownloadIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton> */}

                        <Tooltip
                            title={row.einvoice_status === "Generated" || row.disable ? "Can't delete tax invoice is already generated or cancelled" : ""}
                        >
                            <span>
                                <IconButton
                                    size="medium"
                                    disabled={row.einvoice_status === "Generated" || row.disable}
                                    title="Delete Tax Invoice"
                                    onClick={() => handlInvoiceDelete(row.id)}
                                    sx={{ "&.Mui-disabled": { cursor: "not-allowed" } }}
                                >
                                    <DeleteIcon fontSize="medium" style={{ color: "#455a64" }} />
                                </IconButton>
                            </span>
                        </Tooltip>

                        <Tooltip title="E-Way Bill">
                        <IconButton
                            size="medium"
                            onClick={() => handleEWayBill(row)}
                        >
                            <ReceiptLong fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        </Tooltip>

                        {/* <IconButton
                            size="medium"
                            disabled={row.einvoice_status === "Generated"}
                            title="Cancel Tax Invoice"
                        >
                            <CancelIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton> */}


                    </div>
                );
            },
            filterable: false,
        },
    ];

    useEffect(() => {
        getMasterData()
        getTaxInvoiceData()
        getServiceData()
        getProductData()
    }, [])

    useEffect(() => {
        if (taxInvoiceFormData.recipeint_id && taxInvoiceDailogKey === "add" || "edit") {
            getRecipientMasterById()
        }
    }, [taxInvoiceFormData.legal_name, taxInvoiceFormData.gstin])



    useEffect(() => {
        if (!openTaxInvoiceForm) {
            clearTaxInvoiceForm()
            clearTaxInvoiceLineItemData()
        }
    }, [openTaxInvoiceForm])

    useEffect(() => {
        ValidatorForm.addValidationRule('isPositive', (value) => {
            return parseFloat(value) > 0;
        });

        ValidatorForm.addValidationRule('max3DecimalPlaces', (value) => {
            if (!value) return true;
            // Allow integers or decimals with up to 3 decimal places
            return /^\d*(\.\d{0,3})?$/.test(value);
            // return /^(?!0(?!\.))\d*(\.\d{0,3})?$/.test(value);
        });

        return () => {
            ValidatorForm.removeValidationRule('isPositive');
            ValidatorForm.removeValidationRule('max3DecimalPlaces');
        };
    }, []);

    useEffect(() => {
        if (!ValidatorForm.hasValidationRule('isValidDate')) {
            ValidatorForm.addValidationRule('isValidDate', (value) => {
                // 1. Allow empty (let 'required' handle it)
                if (!value || value === '') return true;

                // 2. Allow valid Date object (from DatePicker)
                if (value instanceof Date && !isNaN(value)) return true;

                // 3. Allow string: try multiple formats
                if (typeof value === 'string') {
                    // Remove any whitespace
                    const cleaned = value.trim();

                    // Case 1: YYYY-MM-DD (from API)
                    if (/^\d{4}-\d{2}-\d{2}$/.test(cleaned)) {
                        return moment(cleaned, 'YYYY-MM-DD', true).isValid();
                    }

                    // Case 2: DD/MM/YYYY (user input)
                    if (/^\d{2}\/\d{2}\/\d{4}$/.test(cleaned)) {
                        return moment(cleaned, 'DD/MM/YYYY', true).isValid();
                    }

                    // Case 3: Any other format → let moment try strict parsing
                    return moment(cleaned, [
                        'YYYY-MM-DD',
                        'DD/MM/YYYY',
                        'DD-MM-YYYY',
                        'DD.MM.YYYY'
                    ], true).isValid();
                }

                return false;
            });
        }
    }, []);

    const isFormValid = taxInvoiceFormData.voucher_type && taxInvoiceFormData.invoice_type && taxInvoiceFormData.category && taxInvoiceFormData.legal_name &&
        taxInvoiceFormData.gstin && taxInvoiceFormData.picode && taxInvoiceFormData.location && taxInvoiceFormData.address_1 && taxInvoiceFormData.state &&
        taxInvoiceFormData.document_type && taxInvoiceFormData.document_number && taxInvoiceFormData.document_date &&
        taxInvoiceFormData.pos && taxInvoiceFormData.igst_on_intra && taxInvoiceFormData.reverse_charge;


    const getMissingFields = () => {
        const missing = [];

        if (!taxInvoiceFormData.voucher_type) missing.push("Voucher Type");
        if (!taxInvoiceFormData.invoice_type) missing.push("Invoice Type");
        if (!taxInvoiceFormData.category) missing.push("Category");
        if (!taxInvoiceFormData.legal_name) missing.push("Legal Name");
        if (!taxInvoiceFormData.gstin) missing.push("GSTIN");
        if (!taxInvoiceFormData.picode) missing.push("Pincode");
        if (!taxInvoiceFormData.location) missing.push("Location");
        if (!taxInvoiceFormData.address_1) missing.push("Address Line 1");
        if (!taxInvoiceFormData.state) missing.push("State");
        if (!taxInvoiceFormData.document_type) missing.push("Document Type");
        if (!taxInvoiceFormData.document_number) missing.push("Document Number");
        if (!taxInvoiceFormData.document_date) missing.push("Document Date");
        if (!taxInvoiceFormData.pos) missing.push("Place of Supply");
        if (!taxInvoiceFormData.igst_on_intra) missing.push("IGST on Intra");
        if (!taxInvoiceFormData.reverse_charge) missing.push("Reverse Charge");

        return missing;
    };


    const getDispatchFromAndBillToDetails = (transaction_type) => {
        setDispatchFromOptions([])
        setBillToOptions([])
        let payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            transaction_type,
            id: masterId,
            voucher_type: taxInvoiceFormData.voucher_type,
        };

        axios
            .post("/e_invoice_transaction_details", payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    const dispatchFromOptions = res.data.bill_from_dispatch_from || [];
                    const billToOptions = res.data.bill_to_ship_to || [];

                    console.log("Bill To Options:", billToOptions);

                    setDispatchFromOptions(dispatchFromOptions);
                    setBillToOptions(billToOptions);
                    // const hasGstinInDispatch = dispatchFromOptions.some(item => item.recipient_gstin);
                    // const hasGstinInBill = billToOptions.some(item => item.recipient_gstin);

                    // setShowGstinDispatch(hasGstinInDispatch);
                    // setShowGstinBill(hasGstinInBill);

                }
            })
            .catch((err) => {
                console.error("API Error:", err);
                // Optional: show toast/notification
            });
    };

    const getRecipientMasterById = () => {
        axios.get(`/e_invoice_tax_invoice_master_details/${taxInvoiceFormData.recipeint_id}`)
            .then((res) => {
                if (res?.data?.status) {
                    const record = res?.data?.records[0] || {}
                    setTaxInvoiceFormData(prevState => ({
                        ...prevState,
                        picode: record.recipient_pincode,
                        address_1: record.recipient_address_one,
                        address_2: record.recipient_address_two,
                        location: record.recipient_location,
                        state: record.recipient_state,
                        phone_no: record.recipient_phone,
                        email: record.recipient_email
                    }));
                }
            }).catch((err) => {

            })
    }

    const getTaxInvoiceData = () => {
        axios.get(`/e_invoice_tax_invoice_details/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records || []
                    setTaxInvoiceData(records)
                    const recordWithMasterId = records.find(record => record.master_id !== null)
                    const masterIdspec = recordWithMasterId?.master_id
                    setMasterId(masterIdspec)

                }
            }).catch((err) => {

            })
    }

    const getServiceData = () => {
        axios.get(`e_invoice_auto_increment_number/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records
                    setServiceData(records)
                }
            }).catch((err) => {

            })
    }

    const getMasterData = () => {
        axios.get(`/e_invoice_tax_invoice_legal_gstin/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records || []
                    setGstinOptions(records)
                }
            }).catch((err) => {

            })
    }

    const getProductData = () => {
        axios.get(`/e_invoice_product_details/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records || []
                    setProductData(records)
                }
            }).catch((err) => {

            })
    }

    const getAddressByPincodeForAddressDailog = (pinCode, transaction_type) => {
        // setPincodeLoading(true);
        // setPincodeValid(false);
        axios.get(`/einvoice/get_address_info/${pinCode}`)
            .then((res) => {
                if (res?.data?.status) {
                    const { area, district, state, location } = res?.data?.address_info
                    switch (transaction_type) {
                        case 'dispatch_pincode':
                            const [d_firstOption] = dispatchFromOptions || [];
                            const d_legal_name = d_firstOption?.supplier_legal_name || '';
                            const d_gstin = d_firstOption?.supplier_gstin || '';
                            setTaxInvoiceFormData((prev) => ({
                                ...prev,
                                dispatch_gstin: d_gstin || "",
                                dispatch_legal_name: d_legal_name || "",
                                dispatch_location: area || "",
                                dispatch_address_1: district || "",
                                dispatch_address_2: location || "",
                                dispatch_state: state || ""
                            }));

                            break;

                        case 'ship_pincode':
                            const [s_firstOption] = billToOptions || [];
                            console.log("s_firstOption...........", billToOptions)
                            const s_legal_name = s_firstOption?.recipient_legal_name || '';
                            const s_gstin = s_firstOption?.recipient_gstin || '';
                            setTaxInvoiceFormData((prev) => ({
                                ...prev,
                                ship_gstin: s_gstin || "",
                                ship_legal_name: s_legal_name || "",
                                ship_location: area || "",
                                ship_address_1: district || "",
                                ship_address_2: location || "",
                                ship_state: state || ""
                            }));

                        default:
                            break;
                    }

                    // setPincodeError('');
                    // setStateArray(res?.data?.state_data || [])
                    // setPincodeValid(true);
                }
            }).catch((err) => {

            }).finally(() => {
                // setPincodeLoading(false);
            })
    }


    const handleChnageTaxInvoiceForm = (e) => {
        const { name, value } = e.target || e;
        let newValue = {};
        if (e?.target?.newValue) {
            newValue = e.target.newValue;
        }

        let updatedFormData = {
            ...taxInvoiceFormData,
            [name]: value,
        };

        // Helper functions
        const parseNumber = (val) => (val ? parseFloat(val) : 0);
        const parsePercent = (val) => {
            if (!val) return 0;
            const numStr = String(val).replace('%', '');
            const parsed = parseFloat(numStr);
            return isNaN(parsed) ? 0 : parsed / 100;
        };
        const round = (num) => {
            if (!num && num !== 0) return '';
            const n = typeof num === 'string' ? parseFloat(num) : num;
            return isNaN(n) ? '' : parseFloat(n.toFixed(3));
        };

        // === FIXED: Only the POS logic is corrected below ===
        if (name === "pos") {
            const newPosStateCode = getGstCodeByState(value) || "";
            const entityGstin = localStorage.getItem("gst");
            const entityStateCode = entityGstin ? entityGstin.substring(0, 2) : null;

            // Use updatedFormData (current values after change) instead of old taxInvoiceFormData
            const category = updatedFormData.category || "";
            const rcm = updatedFormData.reverse_charge || "No";
            const igst_on_intra = updatedFormData.igst_on_intra || "No";

            const updatedLineItems = (taxInvoiceFormData.tax_invoice_line_items || []).map((item) => {
                const quantity = parseNumber(item.quantity);
                const unit_price = parseNumber(item.unit_price);
                const discount = parseNumber(item.discount);
                const gst_rate = parsePercent(item.gst_rate);
                const cess_rate = parsePercent(item.cess_rate);
                const state_cess_rate = parsePercent(item.state_cess_rate);
                const cess_non_ad_value = parseNumber(item.cess_non_ad_value);
                const other_charges = parseNumber(item.other_charges || 0);

                const gross_amount = quantity * unit_price;
                const taxable_value = gross_amount - discount;
                const gstAmount = taxable_value * gst_rate;

                let igst_value = 0;
                let cgst_value = 0;
                let sgst_value = 0;

                if (rcm === "Yes" && igst_on_intra === "Yes") {
                    igst_value = gstAmount;
                } else if (["B2B", "DEXP"].includes(category)) {
                    if (newPosStateCode === entityStateCode) {
                        cgst_value = gstAmount / 2;
                        sgst_value = gstAmount / 2;
                    } else {
                        igst_value = gstAmount;
                    }
                } else if (["SEZWP", "EXPWP"].includes(category)) {
                    igst_value = gstAmount;
                } else if (category === "EXPWOP") {
                    igst_value = cgst_value = sgst_value = 0;
                } else if (category === "B2C") {
                    if (newPosStateCode === entityStateCode) {
                        cgst_value = gstAmount / 2;
                        sgst_value = gstAmount / 2;
                    } else {
                        igst_value = gstAmount;
                    }
                }

                const cess_ad_value = cess_rate * taxable_value;
                const state_cess_value = state_cess_rate * taxable_value;
                const item_total =
                    taxable_value +
                    igst_value +
                    cgst_value +
                    sgst_value +
                    cess_ad_value +
                    cess_non_ad_value +
                    state_cess_value +
                    other_charges;

                return {
                    ...item,
                    gross_amount: round(gross_amount),
                    taxbale_value: round(taxable_value),
                    igst_value: round(igst_value),
                    cgst_value: round(cgst_value),
                    sgst_value: round(sgst_value),
                    cess_ad_value: round(cess_ad_value),
                    state_cess_value: round(state_cess_value),
                    total_item_amount: round(item_total),
                };
            });

            // Correctly assign updated line items
            updatedFormData.tax_invoice_line_items = updatedLineItems;
        }
        // === End of POS fix ===

        // Rest of your code remains completely unchanged
        if (name === "invoice_type") {
            updatedFormData.voucher_type = ""
            updatedFormData.category = ""
            updatedFormData.gstin = ""
            updatedFormData.legal_name = ""
            updatedFormData.recipeint_id = ""
            updatedFormData.address_1 = ""
            updatedFormData.address_2 = ""
            updatedFormData.picode = ""
            updatedFormData.location = ""
            updatedFormData.state = ""
            if (value === "E-Invoice") {
                updatedFormData.voucher_type = "Sales";
                if (updatedFormData.category === "B2C") {
                    updatedFormData.category = "";
                }
            }
        }

        if (name === "voucher_type") {
            updatedFormData.category = ""
            updatedFormData.gstin = ""
            updatedFormData.legal_name = ""
            updatedFormData.recipeint_id = ""
            updatedFormData.address_1 = ""
            updatedFormData.address_2 = ""
            updatedFormData.picode = ""
            updatedFormData.location = ""
            updatedFormData.state = ""
            updatedFormData.document_type = ""
        }

        if (name === "category") {
            updatedFormData.gstin = ""
            updatedFormData.legal_name = ""
            updatedFormData.recipeint_id = ""
            updatedFormData.address_1 = ""
            updatedFormData.address_2 = ""
            updatedFormData.picode = ""
            updatedFormData.location = ""
            updatedFormData.state = ""
        }

        if (name === "legal_name") {
            updatedFormData.recipeint_id = ""
            updatedFormData.address_1 = ""
            updatedFormData.address_2 = ""
            updatedFormData.picode = ""
            updatedFormData.location = ""
            updatedFormData.state = ""
        }

        if (name === "gstin") {
            if (!value) {
                updatedFormData.legal_name = "";
            } else {
                const match = gstinOptions.find((opt) => opt.id === newValue.id);
                updatedFormData.recipeint_id = match?.id || ""
                updatedFormData.legal_name = match?.legal_name || "";
            }
        }

        if (name === "legal_name") {
            if (!value) {
                updatedFormData.gstin = "";
            } else {
                const match = gstinOptions.find((opt) => opt.id === newValue.id);
                updatedFormData.recipeint_id = match?.id || ""
                updatedFormData.gstin = match?.gstin || "";
            }
        }

        if (name === "document_prefix") {
            if (!value) {
                updatedFormData.document_prefix = "";
            } else {
                const match = serviceData.find((opt) => opt.id === newValue.id);
                updatedFormData.document_number = match?.document_number || "";
                updatedFormData.service_name = match?.service_name || "";
                updatedFormData.document_suffix = match?.suffix || ""
            }
        }

        if (name === "dispatch_pincode") {
            if (!value) {
                updatedFormData.dispatch_pincode = "";
            } else {
                const match = dispatchFromOptions.find((opt) => opt.pincode === value);
                if (match) {
                    updatedFormData.dispatch_gstin = match?.gstin || "";
                    updatedFormData.dispatch_legal_name = match?.legal_name || "";
                    updatedFormData.dispatch_location = match?.location || "";
                    updatedFormData.dispatch_address_1 = match?.address_one || "";
                    updatedFormData.dispatch_address_2 = match?.address_two || "";
                    updatedFormData.dispatch_state = match?.state || ""
                }
                else {
                    if (value && value.length === 6) {
                        getAddressByPincodeForAddressDailog(value, name)
                    }
                }
            }
        }

        if (name === "ship_pincode") {
            if (!value) {
                updatedFormData.ship_pincode = "";
            } else {
                const match = billToOptions.find((opt) => opt.pincode === value);
                if (match) {
                    updatedFormData.ship_gstin = match?.gstin || "";
                    updatedFormData.ship_legal_name = match?.legal_name || "";
                    updatedFormData.ship_location = match?.location || "";
                    updatedFormData.ship_address_1 = match?.address_one || "";
                    updatedFormData.ship_address_2 = match?.address_two || "";
                    updatedFormData.ship_state = match?.state || ""
                } else {
                    if (value && value.length === 6) {
                        getAddressByPincodeForAddressDailog(value, name)
                    }
                }
            }
        }

        if (name === "transaction_type" && updatedFormData.transaction_type && updatedFormData.transaction_type !== "Regular") {
            getDispatchFromAndBillToDetails(updatedFormData.transaction_type)
            setOpenAddressDialog(true);
        }

        setTaxInvoiceFormData(updatedFormData);
    };

    // const handleChnageTaxInvoiceForm = (e) => {
    //     const { name, value } = e.target || e;
    //     let newValue = {}

    //     if (e?.target?.newValue) {
    //         newValue = e?.target?.newValue
    //     }

    //     let updatedFormData = {
    //         ...taxInvoiceFormData,
    //         [name]: value,
    //     };

    //     // Helper functions (assume these exist in your component)
    // const parseNumber = (val) => (val ? parseFloat(val) : 0);
    // const parsePercent = (val) => {
    //     if (!val) return 0;
    //     const numStr = String(val).replace('%', '');
    //     const parsed = parseFloat(numStr);
    //     return isNaN(parsed) ? 0 : parsed / 100;
    // };
    // const round = (num) => {
    //     if (!num && num !== 0) return '';
    //     const n = typeof num === 'string' ? parseFloat(num) : num;
    //     return isNaN(n) ? '' : parseFloat(n.toFixed(3));
    // };

    // // === 1. When Place of Supply (pos) changes → Recalculate taxes in ALL line items ===
    // if (name === "pos") {
    //     const newPosStateCode = getGstCodeByState(value) || "";
    //     const entityGstin = localStorage.getItem("gst");
    //     const entityStateCode = entityGstin ? entityGstin.substring(0, 2) : null;
    //     const category = updatedFormData.category || "";
    //     const rcm = updatedFormData.reverse_charge || "No";
    //     const igst_on_intra = updatedFormData.igst_on_intra || "No";

    //     const updatedLineItems = (taxInvoiceFormData.tax_invoice_line_items || []).map((item) => {
    //         const quantity = parseNumber(item.quantity);
    //         const unit_price = parseNumber(item.unit_price);
    //         const discount = parseNumber(item.discount);
    //         const gst_rate = parsePercent(item.gst_rate);
    //         const cess_rate = parsePercent(item.cess_rate);
    //         const state_cess_rate = parsePercent(item.state_cess_rate);
    //         const cess_non_ad_value = parseNumber(item.cess_non_ad_value);
    //         const other_charges = parseNumber(item.other_charges || 0);

    //         const gross_amount = quantity * unit_price;
    //         const taxable_value = gross_amount - discount;
    //         const gstAmount = taxable_value * gst_rate;

    //         let igst_value = 0;
    //         let cgst_value = 0;
    //         let sgst_value = 0;

    //         // Tax logic based on GST rules
    //         if (rcm === "Yes" && igst_on_intra === "Yes") {
    //             igst_value = gstAmount;
    //         } else if (["B2B", "DEXP"].includes(category)) {
    //             if (newPosStateCode === entityStateCode) {
    //                 cgst_value = gstAmount / 2;
    //                 sgst_value = gstAmount / 2;
    //             } else {
    //                 igst_value = gstAmount;
    //             }
    //         } else if (["SEZWP", "EXPWP"].includes(category)) {
    //             igst_value = gstAmount;
    //         } else if (category === "EXPWOP") {
    //             igst_value = cgst_value = sgst_value = 0;
    //         } else if (category === "B2C") {
    //             if (newPosStateCode === entityStateCode) {
    //                 cgst_value = gstAmount / 2;
    //                 sgst_value = gstAmount / 2;
    //             } else {
    //                 igst_value = gstAmount;
    //             }
    //         }

    //         const cess_ad_value = cess_rate * taxable_value;
    //         const state_cess_value = state_cess_rate * taxable_value;
    //         const item_total =
    //             taxable_value +
    //             igst_value +
    //             cgst_value +
    //             sgst_value +
    //             cess_ad_value +
    //             cess_non_ad_value +
    //             state_cess_value +
    //             other_charges;

    //         return {
    //             ...item,
    //             gross_amount: round(gross_amount),
    //             taxbale_value: round(taxable_value), // Note: typo in key, keep as-is if backend expects it
    //             igst_value: round(igst_value),
    //             cgst_value: round(cgst_value),
    //             sgst_value: round(sgst_value),
    //             cess_ad_value: round(cess_ad_value),
    //             state_cess_value: round(state_cess_value),
    //             total_item_amount: round(item_total),
    //         };
    //     });

    //     updatedFormData.tax_invoice_line_items = updatedLineItems;
    // }

    //     if (name === "invoice_type") {

    //         // When switching AWAY from E-Invoice to Tax Invoice (or others)
    //         // Reset fields that are specific to E-Invoice requirements
    //         updatedFormData.voucher_type = ""
    //         updatedFormData.category = ""
    //         updatedFormData.gstin = ""
    //         updatedFormData.legal_name = ""
    //         updatedFormData.recipeint_id = ""
    //         updatedFormData.address_1 = ""
    //         updatedFormData.address_2 = ""
    //         updatedFormData.picode = ""
    //         updatedFormData.location = ""
    //         updatedFormData.state = ""

    //         if (value === "E-Invoice") {
    //             updatedFormData.voucher_type = "Sales";
    //             if (updatedFormData.category === "B2C") {
    //                 updatedFormData.category = "";
    //             }
    //         }
    //     }


    //     // if (name === "invoice_type" && value === "E-Invoice") {
    //     //     updatedFormData.voucher_type = "Sales";

    //     //     if (updatedFormData.category === "B2C") {
    //     //         updatedFormData.category = "";
    //     //     }
    //     // }

    //     if (name === "voucher_type") {
    //         updatedFormData.category = ""
    //         updatedFormData.gstin = ""
    //         updatedFormData.legal_name = ""
    //         updatedFormData.recipeint_id = ""
    //         updatedFormData.address_1 = ""
    //         updatedFormData.address_2 = ""
    //         updatedFormData.picode = ""
    //         updatedFormData.location = ""
    //         updatedFormData.state = ""
    //         updatedFormData.document_type=""

    //     }

    //     if (name === "category") {
    //         updatedFormData.gstin = ""
    //         updatedFormData.legal_name = ""
    //         updatedFormData.recipeint_id = ""
    //         updatedFormData.address_1 = ""
    //         updatedFormData.address_2 = ""
    //         updatedFormData.picode = ""
    //         updatedFormData.location = ""
    //         updatedFormData.state = ""

    //     }
    //     if (name === "legal_name") {
    //         updatedFormData.recipeint_id = ""
    //         updatedFormData.address_1 = ""
    //         updatedFormData.address_2 = ""
    //         updatedFormData.picode = ""
    //         updatedFormData.location = ""
    //         updatedFormData.state = ""
    //     }
    //     if (name === "gstin") {
    //         if (!value) {
    //             updatedFormData.legal_name = "";
    //         } else {
    //             const match = gstinOptions.find((opt) => opt.id === newValue.id);
    //             updatedFormData.recipeint_id = match?.id || ""
    //             updatedFormData.legal_name = match?.legal_name || "";
    //         }
    //     }

    //     if (name === "legal_name") {
    //         if (!value) {
    //             updatedFormData.gstin = "";
    //         } else {
    //             const match = gstinOptions.find((opt) => opt.id === newValue.id);
    //             updatedFormData.recipeint_id = match?.id || ""
    //             updatedFormData.gstin = match?.gstin || "";
    //         }
    //     }

    //     if (name === "document_prefix") {

    //         if (!value) {
    //             updatedFormData.document_prefix = "";
    //         } else {
    //             const match = serviceData.find((opt) => opt.id === newValue.id);
    //             updatedFormData.document_number = match?.document_number || "";
    //             updatedFormData.service_name = match?.service_name || "";
    //             updatedFormData.document_suffix = match?.suffix || ""
    //         }
    //     }

    //     if (name === "dispatch_pincode") {
    //         if (!value) {
    //             updatedFormData.dispatch_pincode = "";
    //         } else {
    //             const match = dispatchFromOptions.find((opt) => opt.pincode === value);
    //             if (match) {
    //                 updatedFormData.dispatch_gstin = match?.gstin || "";
    //                 updatedFormData.dispatch_legal_name = match?.legal_name || "";
    //                 updatedFormData.dispatch_location = match?.location || "";
    //                 updatedFormData.dispatch_address_1 = match?.address_one || "";
    //                 updatedFormData.dispatch_address_2 = match?.address_two || "";
    //                 updatedFormData.dispatch_state = match?.state || ""
    //             }
    //             else {
    //                 if (value && value.length === 6) {
    //                     getAddressByPincodeForAddressDailog(value, name)
    //                 }
    //             }
    //         }
    //     }

    //     if (name === "ship_pincode") {
    //         if (!value) {
    //             updatedFormData.ship_pincode = "";
    //         } else {
    //             const match = billToOptions.find((opt) => opt.pincode === value);


    //             if (match) {
    //                 updatedFormData.ship_gstin = match?.gstin || "";
    //                 updatedFormData.ship_legal_name = match?.legal_name || "";
    //                 updatedFormData.ship_location = match?.location || "";
    //                 updatedFormData.ship_address_1 = match?.address_one || "";
    //                 updatedFormData.ship_address_2 = match?.address_two || "";
    //                 updatedFormData.ship_state = match?.state || ""
    //             } else {
    //                 if (value && value.length === 6) {
    //                     getAddressByPincodeForAddressDailog(value, name)
    //                 }
    //             }
    //         }
    //     }

    //     if (name === "transaction_type" && updatedFormData.transaction_type && updatedFormData.transaction_type !== "Regular") {
    //         getDispatchFromAndBillToDetails(updatedFormData.transaction_type)
    //         setOpenAddressDialog(true);
    //     }


    //     setTaxInvoiceFormData(updatedFormData);
    // };

    const clearTaxInvoiceForm = () => {
        setTaxInvoiceFormData({
            invoice_type: '',
            voucher_type: '',
            category: '',
            legal_name: '',
            gstin: '',
            erp_code: '',
            reverse_charge: 'No',
            address_1: '',
            address_2: '',
            document_type: '',
            location: '',
            state: '',
            document_prefix: '',
            document_suffix: '',
            document_number: '',
            service_name: '',
            picode: '',
            email: '',
            document_date: '',
            original_invoice_date: '',
            original_invoice_no: '',
            phone_no: '',
            pos: '',
            igst_on_intra: 'No',
            transaction_type: 'Regular',
            recipeint_id: '',
            dispatch_gstin: '',
            dispatch_legal_name: '',
            dispatch_location: '',
            dispatch_pincode: '',
            dispatch_address_1: '',
            dispatch_address_2: '',
            dispatch_state: '',
            ship_gstin: '',
            ship_legal_name: '',
            ship_location: '',
            ship_pincode: '',
            ship_address_1: '',
            ship_address_2: '',
            ship_state: '',
            other_charges: '',
            discount: '',
            round_off: ''
        })

    }

    const updateTaxInvoice = (payLoadData) => {
        axios.put('/e_invoice_tax_invoice_update', payLoadData)
            .then((res) => {
                console.log(payLoadData);
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseTaxInvoiceFormDialog();
                    setSubmitted(true)
                    clearTaxInvoiceForm()
                    setTaxInvoiceForm(false)
                    getServiceData()
                } else {
                    handleSnackbarOpen(res?.data?.message, 'warning');
                }
            }).catch((err) => {
            }).finally(() => {
                setSubmitButtonLoading(false);
                getTaxInvoiceData()
            });
    }

    const createTaxInvoice = (payLoadData) => {
        axios.post('/e_invoice_tax_invoice_create', payLoadData)
            .then((res) => {
                console.log(payLoadData);
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    setSubmitted(false)
                    handleCloseTaxInvoiceFormDialog();
                    clearTaxInvoiceForm()
                    setTaxInvoiceForm(false)
                    getServiceData()
                } else {
                    handleSnackbarOpen(res?.data?.message, 'warning');
                }
            }).catch((err) => {
            }).finally(() => {
                setSubmitButtonLoading(false);
                getTaxInvoiceData()
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);

        const transactionType = taxInvoiceFormData.transaction_type;

        const isBillFromDispatchFrom = transactionType === 'Bill From - Dispatch From';
        const isBillToShipTo = transactionType === 'Bill To - Ship To';
        const isCombination = transactionType === 'Combination 2 & 3';

        const requiredDispatchFields = [
            'dispatch_legal_name',
            'dispatch_location',
            'dispatch_pincode',
            'dispatch_address_1',
            'dispatch_state'
        ];

        const requiredShipFields = [
            'ship_gstin',
            'ship_legal_name',
            'ship_location',
            'ship_pincode',
            'ship_address_1',
            'ship_state'
        ];

        const isDispatchMissing = requiredDispatchFields.some(field => !taxInvoiceFormData[field]);
        const isShipMissing = requiredShipFields.some(field => !taxInvoiceFormData[field]);

        if (isCombination) {
            if (isDispatchMissing || isShipMissing) {
                handleSnackbarOpen('Dispatch From and Ship To details are required', 'warning');
                return;
            }
        } else if (isBillFromDispatchFrom && isDispatchMissing) {
            handleSnackbarOpen('Dispatch From details are required', 'warning');
            return;
        } else if (isBillToShipTo && isShipMissing) {
            handleSnackbarOpen('Ship To details are required', 'warning');
            return;
        }

        setHasUnsavedChanges(false);
        setSubmitButtonLoading(true);
        const payLoadData = {
            ...taxInvoiceFormData,
            document_date: moment(taxInvoiceFormData.document_date).format("YYYY-MM-DD"),
            original_invoice_date: taxInvoiceFormData.original_invoice_date
                ? moment(taxInvoiceFormData.original_invoice_date).format("YYYY-MM-DD")
                : "",
            business_entity_id: localStorage.getItem('business_entity_id'),
            grand_total: calculateGrandTotal(),
            entity_gstin: localStorage.getItem('gst'),
            branch_name: localStorage.getItem('branch_name')
        };
        const isEdit = taxInvoiceDailogKey === "edit"
        if (isEdit) {
            updateTaxInvoice(payLoadData);
        } else {
            createTaxInvoice(payLoadData);
        }
    }

    const handleCloseTaxInvoiceFormDialog = () => {
        setHasUnsavedChanges(false);
        clearTaxInvoiceForm()
        setProductDailogOpen(false)
    }

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };



    const handleExportExcel = () => {
        const payload = {
            business_entity_id: localStorage.getItem('business_entity_id')
        }

        const fileName = 'Invoice Details';


        const url = `/e_invoice_tax_invoice_download`;

        axios.post(url, payload)
            .then(response => {

                // Assuming the response data is a Base64 encoded string
                const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                const base64Data = response.data.file; // Adjust based on the actual response format
                downloadBase64File(contentType, base64Data, `${fileName}.xlsx`);
            })
            .catch(error => {
                console.error("Error exporting file:", error);
            });

    }

    const handleOpenTaxInvoiceDailog = (dailogKey, record = {}) => {
        // ✅ Check for unsaved changes before opening ANY dialog (add, view, or edit)
        // BUT only check if we're currently in add or edit mode (not view mode)
        if (hasUnsavedChanges && openTaxInvoiceForm && (taxInvoiceDailogKey === "add" || taxInvoiceDailogKey === "edit")) {
            // Store the pending action to execute after confirmation
            setPendingClose(true);
            setShowDiscardDialog(true);
            // Store the action and record to execute after discard
            setSelectedTaxInvoice(record);
            setPendingTaxInvoiceDailogKey(dailogKey); // ✅ Store in separate state
            return; // Don't proceed with opening yet
        }

        setTaxInvoiceDailogKey(dailogKey)
        setSelectedTaxInvoice(record)
        if (dailogKey === "edit" || dailogKey === "view") {
            setTaxInvoiceFormData({
                invoice_type: record.invoice_type,
                voucher_type: record.voucher_type,
                category: record.inv_det_category,
                legal_name: record.inv_det_legal_name,
                gstin: record.inv_det_gstin,
                reverse_charge: record.inv_det_reverse_charge,
                address_1: record.inv_det_address_one,
                address_2: record.inv_det_address_two,
                document_type: record.inv_det_document_type,
                location: record.inv_det_location,
                state: record.inv_det_state,
                document_prefix: record.document_prefix,
                document_suffix: '',
                document_number: record.inv_det_document_number,
                service_name: record.service,
                picode: record.inv_det_pincode,
                email: record.inv_det_email,
                document_date: record.inv_det_document_date,
                original_invoice_date: record.original_invoice_date,
                original_invoice_no: record.original_invoice_number,
                phone_no: record.inv_det_phone_number,
                pos: record.place_of_supply,
                igst_on_intra: record.inv_det_igst_on_intra,
                transaction_type: record.inv_det_transaction_type,
                recipeint_id: '',
                dispatch_gstin: '',
                dispatch_legal_name: record.dispatch_det_legal_name,
                dispatch_location: record.dispatch_det_location,
                dispatch_pincode: record.dispatch_det_pin_code,
                dispatch_address_1: record.dispatch_det_address_one,
                dispatch_address_2: record.dispatch_det_address_two,
                dispatch_state: record.dispatch_det_state,
                ship_gstin: record.ship_gstin,
                ship_legal_name: record.shipping_det_legal_name,
                ship_location: record.shipping_det_location,
                ship_pincode: record.shipping_det_pin_code,
                ship_address_1: record.shipping_det_address_one,
                ship_address_2: record.shipping_det_address_two,
                ship_state: record.shipping_det_state,
                tax_invoice_line_items: record.products,
                discount: record.overall_discount,
                round_off: record.overall_round_off,
                grand_total: record.amount_det_total_item_amount,
                other_charges: record.other_charges,
                common_tax_invoice_id: record.common_tax_invoice_id
            })
        }
        setTaxInvoiceForm(true)
        setInitialFormData(null);
    }

    const CustomToolbar = () => (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '60px',
                flexWrap: 'wrap',
                gap: 1,
                padding: '3px 10px',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <GridToolbarColumnsButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarFilterButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarDensitySelector
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
                <Button
                    variant="outlined"
                    onClick={handleExportExcel}
                    size="small"
                    sx={{
                        color: '#26A69A',
                        borderRadius: '4px',
                        textTransform: 'none',
                        padding: '2px 10px',
                        borderColor: '#26A69A',
                        height: '40px'
                    }}
                >
                    <DownloadIcon sx={{ marginRight: '4px', fontSize: '18px' }} /> EXPORT
                </Button>
                <Button
                    variant="contained"
                    startIcon={<ControlPointIcon />}
                    onClick={() => handleOpenTaxInvoiceDailog("add")}
                    style={{ height: '40px', backgroundColor: '#00b0ff' }}
                >
                    Add Tax Invoice
                </Button>
            </Box>
        </Box>
    );

    const handleEyeClick = () => {
        const allowedTypes = [
            "Bill From - Dispatch From",
            "Bill To - Ship To",
            "Combination 2 & 3",
        ];

        if (taxInvoiceFormData.transaction_type && allowedTypes.includes(taxInvoiceFormData.transaction_type)) {
            getDispatchFromAndBillToDetails(taxInvoiceFormData.transaction_type)
            setOpenAddressDialog(true);
        }
    };

    const getGstCodeByState = (stateName) => {
        const state = stateOptions.find(
            (option) => option.state.toLowerCase() === stateName.toLowerCase()
        );
        return state ? state.gstCode : null;
    };

    // const handleChangeLineItem = (e) => {
    //     const { name, value } = e.target || e;
    //     const newValue = e?.target?.newValue || {};

    //     let updatedFormDataTaxLine = {
    //         ...taxInvoiceLineItemFormData,
    //         [name]: value,
    //     };

    //     if (name === "product_description") {
    //         if (!value) {
    //             updatedFormDataTaxLine.legal_name = "";
    //         } else {
    //             const match = productData.find((opt) => opt.id === newValue.id);
    //             updatedFormDataTaxLine = {
    //                 ...updatedFormDataTaxLine,
    //                 product_id: match?.id || "",
    //                 hsn_sac_code: match?.hsn_code || "",
    //                 product_description: match?.product_description || "",
    //                 is_service: match?.is_service || "",
    //                 unit: match?.unit || "",
    //                 unit_price: match?.unit_price || "",
    //                 // gst_rate: match?.gst_rate || "",
    //                 gst_rate: taxInvoiceFormData.category === "EXPWOP" ? "0" : match?.gst_rate || "",
    //                 cess_rate: match?.cess_ad_rate || "",
    //                 cess_non_ad_value: match?.cess_non_adj_amt || "",
    //                 state_cess_rate: match?.state_cess_rate || "",
    //                 quantity: '',
    //                 free_quantity: '',
    //                 gross_amount: '',
    //                 discount: ''
    //             };
    //         }
    //     }

    //     const parsePercent = (str) => parseFloat(String(str).replace('%', '') || '') / 100;
    //     //const round = (num) => parseFloat((num || '').toFixed(3));
    //     const round = (num) => {
    //         if (!num) return '';
    //         return parseFloat(num.toFixed(3));
    //     };
    //     const place_of_supply = getGstCodeByState(taxInvoiceFormData.pos) || "";
    //     const category = taxInvoiceFormData.category || ""
    //     const entityGstin = localStorage.getItem("gst");
    //     const entityStateCode = entityGstin ? entityGstin.substring(0, 2) : null;
    //     const rcm = taxInvoiceFormData.reverse_charge
    //     const igst_on_intra = taxInvoiceFormData.igst_on_intra


    //     const quantity = parseFloat(updatedFormDataTaxLine.quantity || 0);
    //     const unit_price = parseFloat(updatedFormDataTaxLine.unit_price || 0);
    //     const discount = parseFloat(updatedFormDataTaxLine.discount || 0);
    //     const gst_rate = parsePercent(updatedFormDataTaxLine.gst_rate);
    //     const cess_rate = parsePercent(updatedFormDataTaxLine.cess_rate);
    //     const state_cess_rate = parsePercent(updatedFormDataTaxLine.state_cess_rate);
    //     const cess_non_ad_value = parseFloat(updatedFormDataTaxLine.cess_non_ad_value || 0);
    //     const state_cess_non_ad_value = parseFloat(updatedFormDataTaxLine.state_cess_non_ad_value || 0);
    //     const other_charges = parseFloat(updatedFormDataTaxLine.other_charges || 0);

    //     const gross_amount = quantity * unit_price;
    //     const taxable_value = gross_amount - discount;

    //     let sgst_value = 0, cgst_value = 0, igst_value = 0;
    //     const gstAmount = taxable_value * gst_rate;

    //     // If RCM is Y and IGST on Intra is Y then it will be always IGST
    //     if (rcm === 'Yes' && igst_on_intra === "Yes") {
    //         igst_value = gstAmount;
    //     }

    //     // Rule 1 & 2: B2B or DEXP
    //     else if (["B2B", "DEXP"].includes(category)) {
    //         console.log("B2B, place of supply, entityStateCode", place_of_supply, entityStateCode)
    //         if (place_of_supply === entityStateCode) {
    //             // Intra → CGST + SGST
    //             cgst_value = gstAmount / 2;
    //             sgst_value = gstAmount / 2;
    //         } else {
    //             // Inter → IGST
    //             igst_value = gstAmount;
    //         }
    //     }

    //     // Rule 3 & 4: SEZWP or SEZWOP → Always IGST
    //     else if (["SEZWP"].includes(category)) {
    //         igst_value = gstAmount;
    //     }

    //     // Rule 5: EXPWOP to other country → Zero tax
    //     else if (category === "EXPWOP") {
    //         igst_value = 0;
    //         cgst_value = 0;
    //         sgst_value = 0;
    //     }

    //     // Rule 6: EXPWP to other country → IGST
    //     else if (category === "EXPWP") {
    //         igst_value = gstAmount;
    //     }

    //     // Rule 7 & 8: B2C (unregistered)
    //     else if (category === "B2C") {
    //         if (place_of_supply === entityStateCode) {
    //             // Intra → CGST + SGST
    //             cgst_value = gstAmount / 2;
    //             sgst_value = gstAmount / 2;
    //         } else {
    //             // Inter → IGST
    //             igst_value = gstAmount;
    //         }
    //     }

    //     const cess_ad_value = cess_rate * taxable_value;
    //     const state_cess_value = state_cess_rate * taxable_value;

    //     const item_total = taxable_value
    //         + igst_value
    //         + cgst_value
    //         + sgst_value
    //         + cess_ad_value
    //         + cess_non_ad_value
    //         + state_cess_value
    //         + state_cess_non_ad_value
    //         + other_charges;

    //     updatedFormDataTaxLine = {
    //         ...updatedFormDataTaxLine,
    //         quantity: round(quantity),
    //         gross_amount: round(gross_amount),
    //         taxbale_value: round(taxable_value),
    //         sgst_value: round(sgst_value),
    //         cgst_value: round(cgst_value),
    //         igst_value: round(igst_value),
    //         cess_ad_value: round(cess_ad_value),
    //         state_cess_value: round(state_cess_value),
    //         total_item_amount: round(item_total),
    //     };

    //     setTaxInvoiceLineItemFormData(updatedFormDataTaxLine);
    // };

    const handleChangeLineItem = (e) => {
        const { name, value } = e.target || e;
        const newValue = e?.target?.newValue || {};

        let updatedFormDataTaxLine = {
            ...taxInvoiceLineItemFormData,
            [name]: value,
        };

        if (name === "product_description") {
            if (!value) {
                updatedFormDataTaxLine.legal_name = "";
            } else {
                const match = productData.find((opt) => opt.id === newValue.id);
                updatedFormDataTaxLine = {
                    ...updatedFormDataTaxLine,
                    product_id: match?.id || "",
                    hsn_sac_code: match?.hsn_code || "",
                    product_description: match?.product_description || "",
                    is_service: match?.is_service || "",
                    unit: match?.unit || "",
                    unit_price: match?.unit_price || "",
                    // gst_rate: match?.gst_rate || "",
                    gst_rate: taxInvoiceFormData.category === "EXPWOP" ? "0" : match?.gst_rate || "",
                    cess_rate: match?.cess_ad_rate || "",
                    cess_non_ad_value: match?.cess_non_adj_amt || "",
                    state_cess_rate: match?.state_cess_rate || "",
                    quantity: '',
                    free_quantity: '',
                    gross_amount: '',
                    discount: ''
                };
            }
        }


        const parsePercent = (str) => {
            if (!str) return 0;
            const numStr = String(str).replace('%', '');
            const parsed = parseFloat(numStr);
            return isNaN(parsed) ? 0 : parsed / 100;
        };

        const parseNumber = (str) => {
            if (!str) return 0;
            const parsed = parseFloat(str);
            return isNaN(parsed) ? 0 : parsed;
        };


        const round = (num) => {
            if (!num && num !== 0) return '';
            if (typeof num === 'string' && num.trim() === '') return '';
            const numValue = typeof num === 'string' ? parseFloat(num) : num;
            if (isNaN(numValue)) return '';
            return parseFloat(numValue.toFixed(3));
        };

        const place_of_supply = getGstCodeByState(taxInvoiceFormData.pos) || "";
        const category = taxInvoiceFormData.category || ""
        const entityGstin = localStorage.getItem("gst");
        const entityStateCode = entityGstin ? entityGstin.substring(0, 2) : null;
        const rcm = taxInvoiceFormData.reverse_charge
        const igst_on_intra = taxInvoiceFormData.igst_on_intra


        const quantity = parseNumber(updatedFormDataTaxLine.quantity);
        const unit_price = parseNumber(updatedFormDataTaxLine.unit_price);
        const discount = parseNumber(updatedFormDataTaxLine.discount);
        const gst_rate = parsePercent(updatedFormDataTaxLine.gst_rate);
        const cess_rate = parsePercent(updatedFormDataTaxLine.cess_rate);
        const state_cess_rate = parsePercent(updatedFormDataTaxLine.state_cess_rate);
        const cess_non_ad_value = parseNumber(updatedFormDataTaxLine.cess_non_ad_value);
        const state_cess_non_ad_value = parseNumber(updatedFormDataTaxLine.state_cess_non_ad_value);
        const other_charges = parseNumber(updatedFormDataTaxLine.other_charges);

        const gross_amount = quantity * unit_price;
        const taxable_value = gross_amount - discount;

        let sgst_value = 0, cgst_value = 0, igst_value = 0;
        const gstAmount = taxable_value * gst_rate;

        // If RCM is Y and IGST on Intra is Y then it will be always IGST
        if (rcm === 'Yes' && igst_on_intra === "Yes") {
            igst_value = gstAmount;
        }

        // Rule 1 & 2: B2B or DEXP
        else if (["B2B", "DEXP"].includes(category)) {
            console.log("B2B, place of supply, entityStateCode", place_of_supply, entityStateCode)
            if (place_of_supply === entityStateCode) {
                // Intra → CGST + SGST
                cgst_value = gstAmount / 2;
                sgst_value = gstAmount / 2;
            } else {
                // Inter → IGST
                igst_value = gstAmount;
            }
        }

        // Rule 3 & 4: SEZWP or SEZWOP → Always IGST
        else if (["SEZWP"].includes(category)) {
            igst_value = gstAmount;
        }

        // Rule 5: EXPWOP to other country → Zero tax
        else if (category === "EXPWOP") {
            igst_value = 0;
            cgst_value = 0;
            sgst_value = 0;
        }

        // Rule 6: EXPWP to other country → IGST
        else if (category === "EXPWP") {
            igst_value = gstAmount;
        }

        // Rule 7 & 8: B2C (unregistered)
        else if (category === "B2C") {
            if (place_of_supply === entityStateCode) {
                // Intra → CGST + SGST
                cgst_value = gstAmount / 2;
                sgst_value = gstAmount / 2;
            } else {
                // Inter → IGST
                igst_value = gstAmount;
            }
        }

        const cess_ad_value = cess_rate * taxable_value;
        const state_cess_value = state_cess_rate * taxable_value;

        const item_total = taxable_value
            + igst_value
            + cgst_value
            + sgst_value
            + cess_ad_value
            + cess_non_ad_value
            + state_cess_value
            + state_cess_non_ad_value
            + other_charges;

        updatedFormDataTaxLine = {
            ...updatedFormDataTaxLine,
            quantity: updatedFormDataTaxLine.quantity,
            gross_amount: round(gross_amount),
            taxbale_value: round(taxable_value),
            sgst_value: round(sgst_value),
            cgst_value: round(cgst_value),
            igst_value: round(igst_value),
            cess_ad_value: round(cess_ad_value),
            state_cess_value: round(state_cess_value),
            total_item_amount: round(item_total),
        };

        setTaxInvoiceLineItemFormData(updatedFormDataTaxLine);
    };

    const handleAddTaxInvoiceLineItem = () => {
        setTaxInvoiceLineAction('add')
        setTaxInvoiceLineItemDailog(true)
    }

    const handleViewTaxInvoiceLineItem = (sr_no) => {
        const item = taxInvoiceFormData.tax_invoice_line_items.find(
            line => line.sr_no === sr_no
        );
        console.log("taxInvoiceFormData.tax_invoice_line_items.........", taxInvoiceFormData.tax_invoice_line_items)
        if (item) {
            setTaxInvoiceLineItemFormData(item);
            setTaxInvoiceLineAction('view');
            setTaxInvoiceLineItemDailog(true);
        }
    };

    const handleEditTaxInvoiceLineItem = (sr_no) => {
        const item = taxInvoiceFormData.tax_invoice_line_items.find(
            line => line.sr_no === sr_no
        );

        if (item) {
            setTaxInvoiceLineItemFormData(item);
            setTaxInvoiceLineAction('edit');
            setTaxInvoiceLineItemDailog(true);
        }
    };

    const handleDeleteTaxInvoiceLineItem = (sr_no) => {
        setTaxInvoiceFormData(prev => {
            const updatedItems = prev.tax_invoice_line_items
                .filter(item => item.sr_no !== sr_no.toString())
                .map((item, index) => ({
                    ...item,
                    sr_no: (index + 1).toString()
                }));

            return {
                ...prev,
                tax_invoice_line_items: updatedItems
            };
        });
    };

    const handlInvoiceDelete = (row_id) => {
        if (hasUnsavedChanges && openTaxInvoiceForm && (taxInvoiceDailogKey === "add" || taxInvoiceDailogKey === "edit")) {
            setShowDiscardDialog(true);
            setPendingClose(false);
            return;
        }
        axios.delete(`/einvoice/delete_tax_cn_dn_master/${localStorage.getItem('business_entity_id')}/${row_id}/`)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res?.data?.message, 'success');
                    getTaxInvoiceData()
                    handleCloseTaxInvoiceFormDialog();
                    clearTaxInvoiceForm()
                }
            }).catch((err) => {

            })
    }

    const cleaBillToShipToDetails = () => {
        console.log("clearing the form ...............\n\n")
        setTaxInvoiceFormData({
            ...taxInvoiceFormData,
            dispatch_gstin: '',
            dispatch_legal_name: '',
            dispatch_location: '',
            dispatch_pincode: '',
            dispatch_address_1: '',
            dispatch_address_2: '',
            dispatch_state: '',
            ship_gstin: '',
            ship_legal_name: '',
            ship_location: '',
            ship_pincode: '',
            ship_address_1: '',
            ship_address_2: '',
            ship_state: ''
        })
    }

    const clearTaxInvoiceLineItemData = () => {
        setTaxInvoiceLineItemFormData({
            sr_no: '',
            product_id: '',
            product_description: '',
            is_service: '',
            hsn_sac_code: '',
            unit: '',
            quantity: '',
            unit_price: '',
            free_quantity: '',
            gross_amount: '',
            discount: '',
            taxbale_value: '',
            gst_rate: '',
            sgst_value: '',
            cgst_value: '',
            igst_value: '',
            cess_rate: '',
            cess_ad_value: '',
            cess_non_ad_value: '',
            state_cess_rate: '',
            state_cess_value: '',
            state_cess_non_ad_value: '',
            other_charges: '',
            total_item_amount: ''
        });
    }

    const handleSubmitTaxInvoiceLineItem = (e) => {
        e.preventDefault();

        setTaxInvoiceFormData((prev) => {
            const existingItems = Array.isArray(prev.tax_invoice_line_items)
                ? prev.tax_invoice_line_items
                : [];

            if (taxInvoiceLineAction === 'edit') {
                const updatedItems = existingItems.map(item =>
                    item.sr_no === taxInvoiceLineItemFormData.sr_no
                        ? { ...taxInvoiceLineItemFormData }
                        : item
                );

                return {
                    ...prev,
                    tax_invoice_line_items: updatedItems
                };
            } else {
                const nextSrNo = (existingItems.length + 1).toString();

                const newItem = {
                    ...taxInvoiceLineItemFormData,
                    sr_no: nextSrNo
                };

                return {
                    ...prev,
                    tax_invoice_line_items: [...existingItems, newItem]
                };
            }
        });

        clearTaxInvoiceLineItemData();
        setTaxInvoiceLineItemDailog(false);
    };

    const handleSubmiDispatchFromAndBillTo = (e) => {
        e.preventDefault()
        setOpenAddressDialog(false)
    }

    const getTaxInvoiceLineItemTotals = () => {
        const items = taxInvoiceFormData.tax_invoice_line_items || [];

        return items.reduce((totals, item) => {
            const toNumber = (val) => parseFloat(val) || 0;

            const discount = toNumber(item.discount);
            const itemTotal = toNumber(item.total_item_amount);

            return {
                total_taxable_value: totals.total_taxable_value + toNumber(item.taxbale_value),
                total_igst_value: totals.total_igst_value + toNumber(item.igst_value),
                total_cgst_value: totals.total_cgst_value + toNumber(item.cgst_value),
                total_sgst_value: totals.total_sgst_value + toNumber(item.sgst_value),
                total_cess_ad_value: totals.total_cess_ad_value + toNumber(item.cess_ad_value),
                total_cess_non_ad_value: totals.total_cess_non_ad_value + toNumber(item.cess_non_ad_value),
                total_state_cess_value: totals.total_state_cess_value + toNumber(item.state_cess_value),
                total_item_amount: totals.total_item_amount + itemTotal,
            };
        }, {
            total_taxable_value: 0,
            total_igst_value: 0,
            total_cgst_value: 0,
            total_sgst_value: 0,
            total_cess_ad_value: 0,
            total_cess_non_ad_value: 0,
            total_state_cess_value: 0,
            total_item_amount: 0,
        });
    };

    const calculateGrandTotal = () => {
        const totalItemAmount = getTaxInvoiceLineItemTotals().total_item_amount;
        const otherCharges = parseFloat(taxInvoiceFormData.other_charges || 0)
        const discount = parseFloat(taxInvoiceFormData.discount || 0);
        const roundOff = parseFloat(taxInvoiceFormData.round_off || 0);

        return (otherCharges + totalItemAmount - discount + roundOff).toFixed(2);
    };

    const getFilteredGstinOptions = () => {
        const selectedCategory = taxInvoiceFormData.category;
        const selectedVoucherType = taxInvoiceFormData.voucher_type;
        const requiredMasterType = selectedVoucherType === "Sales" ? "CUSTOMER" : "VENDOR";

        switch (selectedCategory) {
            case "EXPWP":
            case "EXPWOP":
                // case "IMPG":
                return gstinOptions.filter(opt => opt.gstin_reg === "Export" && opt.master_type === requiredMasterType);
            // case "EXPWP":
            // case "EXPWOP":
            //     return gstinOptions.filter(opt => opt.gstin_reg === "Export" && opt.master_type === requiredMasterType);

            // case "SEZWP":
            // case "SEZWOP":
            //     return gstinOptions.filter(opt => opt.gstin_reg === "SEZ" && opt.master_type === requiredMasterType);

            case "SEZWP":
            case "SEZWOP":
                // case "IMPG SEZ":
                return gstinOptions.filter(opt => opt.gstin_reg === "SEZ" && opt.master_type === requiredMasterType);

            case "DEXP":
                return gstinOptions.filter(opt => opt.gstin_reg === "Deemed Export" && opt.master_type === requiredMasterType);

            case "IMPG":
                return gstinOptions.filter(opt =>
                    (opt.gstin_reg === "Import" || opt.gstin_reg === "IMPG") &&
                    opt.master_type === requiredMasterType
                );

            case "IMPG SEZ":
                return gstinOptions.filter(opt => opt.gstin_reg === "SEZ" && opt.master_type === requiredMasterType);

            case "B2B":
                return gstinOptions.filter(opt =>
                    (opt.gstin_reg === "Regular" || opt.gstin_reg === "Composition") && opt.master_type === requiredMasterType
                );

            case "B2C":
                return gstinOptions.filter(opt => opt.gstin_reg === "Un-Registered" && opt.master_type === requiredMasterType);

            default:
                return gstinOptions.filter(opt => opt.master_type === requiredMasterType);
        }
    };

    const templateSlide = (row) => {
        if (hasUnsavedChanges && openTaxInvoiceForm && (taxInvoiceDailogKey === "add" || taxInvoiceDailogKey === "edit")) {
            setShowDiscardDialog(true);
            setPendingClose(false);
            return;
        }
        if (!row) return;

        const business_entity_id = localStorage.getItem('business_entity_id');
        const apiUrl = `/einvoice/export_normal_invoice/${business_entity_id}/${row.id}`;

        axios.get(apiUrl)
            .then(response => {
                if (response?.data) {
                const apiData = response.data;

                const hasBankDetails = apiData.bank_info && 
                    apiData.bank_info.account_number &&
                    apiData.bank_info.account_number.trim() !== '';

                if (!hasBankDetails) {
                    handleSnackbarOpen(
                        'Please add bank details before previewing the invoice template.', 
                        'warning'
                    );
                    return;
                }

                    history.push({
                    pathname: `/invoice-template/${row.id}`,
                    state: { invoiceData: apiData }
                    });
                } else {
                    handleSnackbarOpen('Data not found.', 'warning');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                handleSnackbarOpen('Error while fetching invoice data.', 'error');
            });
    };




    const TaxInvoiceForm = () => {
        const isViewMode = taxInvoiceDailogKey === "view";
        const isEditMode = taxInvoiceDailogKey === "edit"

        const categorys = taxInvoiceFormData.voucher_type === "Sales" ? categoryOptions : purchaseCategoryOptions

        const missingFields = getMissingFields();
        const tooltipTitle = missingFields.length
            ? `Please fill the following field(s): ${missingFields.join(", ")}`
            : "";

        const tableContainerStyle = {
            maxHeight: '60vh',
            overflowY: 'auto',
            overflowX: 'hidden', // Keep X hidden to prevent horizontal scroll
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
            marginTop: "3.5%"
        };

        const tdThStyles = {
            fontWeight: 600,
            backgroundColor: '#f4f6f8',
            borderBottom: '2px solid #e0e0e0',
            textAlign: 'center',
            padding: '12px',
            fontSize: '0.9rem',
            color: '#333',
        };

        const cellStyles = {
            borderBottom: '1px solid #eee',
            textAlign: 'center',
            padding: '12px 10px',
            fontSize: '0.875rem',
            color: '#444',
            backgroundColor: '#fff',
        };

        const rowHoverStyle = {
            '&:hover': {
                backgroundColor: '#f9f9f9',
            },
        };


        return (
            <Slide
                direction="up"
                in={openTaxInvoiceForm}
                mountOnEnter
                unmountOnExit
                timeout={500} // Animation duration
            >
                <Paper elevation={3} sx={{ backgroundColor: 'white', py: 4, px: 4, borderRadius: 2, position: 'relative' }}>
                    <IconButton
                        onClick={handleAttemptClose}
                        sx={{
                            position: 'absolute',
                            top: 16,
                            right: 16,
                            border: '1px solid',
                            borderColor: 'error.main',
                            color: 'error.main',
                            borderRadius: '50%',
                            padding: 0.5,

                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mb: 3
                    }}>
                        <Description sx={{ mr: 2, color: 'primary.main' }} />
                        <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                            {isViewMode
                                ? 'View Tax Invoice'
                                : isEditMode
                                    ? 'Edit Tax Invoice'
                                    : 'Add Tax Invoice'}
                        </Typography>

                    </Box>

                    <ValidatorForm
                        useRef="form"
                        onSubmit={handleSubmit}
                        onError={(errors) => console.log(errors)}
                    >
                        <Grid container spacing={5}>

                            <Grid item xs={12} sm={4} mt={1}>

                                <SelectInput
                                    choice_id="invoice_type"
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    choice_name="invoice_type"
                                    SelectLabel="Invoice Type"
                                    name="invoice_type"
                                    value={taxInvoiceFormData.invoice_type}
                                    textOnchangeFunction={handleChnageTaxInvoiceForm}
                                    choices={[
                                        {
                                            "id": 1,
                                            "invoice_type": "Tax Invoice",
                                        },
                                        {
                                            "id": 2,
                                            "invoice_type": "E-Invoice",
                                        }
                                    ]}
                                    disabled={isViewMode}
                                />

                            </Grid>

                            {/* Voucher Type */}
                            <Grid item xs={12} sm={4} mt={1}>

                                <SelectInput
                                    choice_id="voucher_type"
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    choice_name="voucher_type"
                                    SelectLabel="Voucher Type"
                                    name="voucher_type"
                                    value={taxInvoiceFormData.voucher_type}
                                    textOnchangeFunction={handleChnageTaxInvoiceForm}
                                    choices={
                                        taxInvoiceFormData.invoice_type === "E-Invoice"
                                            ? [{ id: 1, voucher_type: "Sales" }]
                                            : [
                                                { id: 1, voucher_type: "Sales" },
                                                { id: 2, voucher_type: "Purchase" }
                                            ]
                                    }
                                    disabled={isViewMode}
                                />
                            </Grid>

                            {/* Category */}
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                mt={3.1}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={
                                        taxInvoiceFormData.invoice_type === "E-Invoice"
                                            ? categorys.filter(opt => opt.category !== "B2C")
                                            : categorys
                                    }
                                    getOptionLabel={(option) => option.category || ""}
                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="category"
                                            label={
                                                <span>
                                                    Category <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.category}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}

                                        />
                                    )}
                                    value={
                                        categorys.find(
                                            (opt) => opt.category === taxInvoiceFormData.category
                                        ) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "category",
                                                value: newValue?.category || "",
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                    disabled={isViewMode}
                                />

                            </Grid>

                            {/* Legal Name */}
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                mt={3.1}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={getFilteredGstinOptions()}
                                    getOptionLabel={(option) => option.legal_name || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="legal_name"
                                            label={
                                                <span>
                                                    Legal Name <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.legal_name}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    )}
                                    value={
                                        gstinOptions.find((opt) => opt.legal_name === taxInvoiceFormData.legal_name) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "legal_name",
                                                value: newValue?.legal_name || "",
                                                newValue: newValue
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        },
                                    }}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            {/* GSTIN */}
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                mt={3.1}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={getFilteredGstinOptions()}
                                    getOptionLabel={(option) => option.gstin || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="gstin"
                                            label={
                                                <span>
                                                    GSTIN <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.gstin}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}

                                        />
                                    )}
                                    value={
                                        gstinOptions.find(
                                            (opt) => opt.gstin === taxInvoiceFormData.gstin
                                        ) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "gstin",
                                                value: newValue?.gstin || "",
                                                newValue: newValue
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                    disabled={isViewMode}

                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <label>
                                    Pincode
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="picode"
                                    value={taxInvoiceFormData.picode}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 6 }}
                                    onKeyPress={(event) => {
                                        if (!/^[0-9]$/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                    errorMessages={["This field is required", "Must be a 6-digit pincode"]}

                                    disabled={isViewMode}

                                />

                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <label>
                                    Location
                                    <span style={{ color: "red" }}>*</span>:
                                </label>

                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="location"
                                    value={taxInvoiceFormData.location}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} >
                                <label>
                                    Address 1
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="address_1"
                                    value={taxInvoiceFormData.address_1}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>

                                <label>
                                    Address 2
                                </label>

                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="address_2"
                                    value={taxInvoiceFormData.address_2}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 100 }}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>

                                <label>
                                    State
                                    <span style={{ color: "red" }}>*</span>:
                                </label>

                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="state"
                                    value={taxInvoiceFormData.state}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 100 }}
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={4}
                                mt={3.1}
                                sx={{
                                    // position: 'relative',
                                    overflow: 'visible',
                                    // zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={
                                        taxInvoiceFormData.voucher_type === "Sales"
                                            ? documentTypesSales
                                            : taxInvoiceFormData.voucher_type === "Purchase"
                                                ? documentTypesPurchase
                                                : []
                                    }
                                    getOptionLabel={(option) => option.document_type || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            label={
                                                <span>
                                                    Document Type <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.document_type}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}

                                        />
                                    )}
                                    value={
                                        (taxInvoiceFormData.voucher_type === "Sales"
                                            ? documentTypesSales
                                            : documentTypesPurchase
                                        ).find((opt) => opt.document_type === taxInvoiceFormData.document_type) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "document_type",
                                                value: newValue?.document_type || "",
                                                newValue: newValue
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                    disabled={isViewMode}
                                />

                            </Grid>

                            {/* Document Prefix*/}
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                mt={3.1}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={serviceData}
                                    getOptionLabel={(option) => option.prefix || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="document_prefix"
                                            label="Document Prefix"
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.document_prefix}
                                        // validators={["required"]}
                                        // errorMessages={["This field is required"]}

                                        />
                                    )}
                                    value={
                                        serviceData.find(
                                            (opt) => opt.prefix === taxInvoiceFormData.document_prefix
                                        ) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "document_prefix",
                                                value: newValue?.prefix || "",
                                                newValue: newValue
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                    disabled={isViewMode}
                                />

                            </Grid>

                            <Grid item xs={12} sm={4} >
                                <label>
                                    Document Number
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <TextValidator
                                    label="Document Number"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="document_number"
                                    value={taxInvoiceFormData.document_number}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 500 }}
                                    requiredField="*"
                                    validators={["required"]}
                                    errorMessages={["This field is required"]}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} >
                                <label>
                                    Service Name

                                </label>
                                <TextValidator
                                    label="Service Name"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="service_name"
                                    value={taxInvoiceFormData.service_name}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 500 }}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} >
                                <label>
                                    Document Date
                                    <span style={{ color: "red" }}>*</span>:
                                </label>
                                <ValidatedDatePicker
                                    name="document_date"
                                    value={taxInvoiceFormData.document_date}
                                    onChange={(v) => {
                                        handleChnageTaxInvoiceForm({
                                            name: "document_date",
                                            value: v,
                                        });
                                    }}

                                    requiredField="*"
                                    validators={["required", "isValidDate"]}
                                    errorMessages={["This field is required", "Enter a valid date (DD/MM/YYYY)"]}

                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} >
                                <label>
                                    Original Invoice Date
                                    {/* <span style={{ color: "red" }}>*</span>: */}
                                </label>
                                <ValidatedDatePicker
                                    name="original_invoice_date"
                                    value={taxInvoiceFormData.original_invoice_date}
                                    onChange={(v) => {
                                        handleChnageTaxInvoiceForm({
                                            name: "original_invoice_date",
                                            value: v,
                                        });
                                    }}
                                    disabled={isViewMode}
                                // requiredField="*"
                                // validators={["required"]}
                                // errorMessages={["This field is required"]}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <label>
                                    Original Invoice No
                                </label>
                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="original_invoice_no"
                                    value={taxInvoiceFormData.original_invoice_no ?? ""}
                                    onChange={handleChnageTaxInvoiceForm}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <label>
                                    Phone Number
                                </label>
                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="phone"
                                    value={taxInvoiceFormData.phone_no ?? ""}
                                    onChange={handleChnageTaxInvoiceForm}
                                    inputProps={{ maxLength: 10 }}
                                    onKeyPress={(event) => {
                                        if (!/^[0-9]$/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    errorMessages={[
                                        "Must be a mobile number",
                                    ]}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <label>
                                    Email
                                </label>
                                <TextValidator
                                    fullWidth={true}
                                    size="small"
                                    variant="outlined"
                                    name="email"
                                    value={taxInvoiceFormData.email ?? ""}
                                    onChange={handleChnageTaxInvoiceForm}
                                    disabled={isViewMode}
                                />
                            </Grid>

                            {/* Place of Supply */}
                            {/* <Grid
                                item
                                xs={12}
                                sm={3}
                                mt={2.99}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={stateOptions}
                                    getOptionLabel={(option) => option.state || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%'
                                        },
                                        placement: 'bottom-start'
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}

                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="pos"
                                            label={
                                                <span>
                                                    Place of Supply <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.pos}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}

                                        />
                                    )}
                                    value={
                                        stateOptions.find(
                                            (opt) => opt.state === taxInvoiceFormData.pos
                                        ) || null
                                    }
                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "pos",
                                                value: newValue?.state || "",
                                            },
                                        });
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                    disabled={isViewMode || isEditMode}
                                />

                            </Grid> */}

                            <Grid
                                item
                                xs={12}
                                sm={3}
                                mt={2.99}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1
                                }}
                            >
                                <Autocomplete
                                    options={stateOptions}
                                    getOptionLabel={(option) => option.state || ""}

                                    // ✅ Keep disablePortal to render dropdown inside the Grid
                                    disablePortal

                                    PopperProps={{
                                        sx: {
                                            position: 'absolute !important',
                                            zIndex: 1400,
                                            width: 'auto',
                                            minWidth: '100%',
                                            // ✅ Constrain within viewport
                                            maxHeight: 'calc(100vh - 100px)',
                                            overflow: 'visible'
                                        },
                                        // ✅ Enable modifiers to handle positioning intelligently
                                        modifiers: [
                                            {
                                                name: 'flip',
                                                enabled: true,
                                                options: {
                                                    // Allow flipping when there's not enough space
                                                    fallbackPlacements: ['top-start', 'bottom-start', 'top', 'bottom'],
                                                },
                                            },
                                            {
                                                name: 'preventOverflow',
                                                enabled: true,
                                                options: {
                                                    // Use the viewport as boundary to prevent overflow
                                                    boundary: 'viewport',
                                                    padding: 8,
                                                },
                                            },
                                            {
                                                name: 'offset',
                                                enabled: true,
                                                options: {
                                                    offset: [0, 4], // Small offset from the input
                                                },
                                            },
                                        ],
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1400,
                                                position: 'absolute'
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)',
                                            // ✅ Ensure listbox doesn't overflow
                                            overflowY: 'auto',
                                            overflowX: 'hidden'
                                        },
                                    }}

                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="pos"
                                            label={
                                                <span>
                                                    Place of Supply <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.pos}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    )}

                                    value={
                                        stateOptions.find(
                                            (opt) => opt.state === taxInvoiceFormData.pos
                                        ) || null
                                    }

                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "pos",
                                                value: newValue?.state || "",
                                            },
                                        });
                                    }}

                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}

                                    disabled={isViewMode}
                                />
                            </Grid>

                            {/* Reverse Charge */}
                            <Grid item xs={12} sm={3} mt={1}>

                                <SelectInput
                                    choice_id="reverse_charge"
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    choice_name="reverse_charge"
                                    SelectLabel="Reverse Charge"
                                    name="reverse_charge"
                                    value={taxInvoiceFormData.reverse_charge}
                                    textOnchangeFunction={handleChnageTaxInvoiceForm}
                                    choices={[
                                        {
                                            "id": 1,
                                            "reverse_charge": "Yes",
                                        },
                                        {
                                            "id": 2,
                                            "reverse_charge": "No",
                                        }
                                    ]}
                                    disabled={isEditMode || isViewMode}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={3}
                                mt={2.99}
                                sx={{
                                    position: 'relative',
                                    overflow: 'visible',
                                    zIndex: 1300 // Higher z-index
                                }}
                            >
                                <Autocomplete
                                    options={transactionTypeOptions}
                                    getOptionLabel={(option) => option.transaction_type || ""}

                                    // ❌ REMOVE disablePortal - This is causing the dropdown to be clipped
                                    // disablePortal

                                    PopperProps={{
                                        sx: {
                                            zIndex: 1500, // Very high z-index to appear above table
                                        },
                                        modifiers: [
                                            {
                                                name: 'flip',
                                                enabled: true,
                                                options: {
                                                    fallbackPlacements: ['top-start', 'bottom-start', 'top', 'bottom'],
                                                },
                                            },
                                            {
                                                name: 'preventOverflow',
                                                enabled: true,
                                                options: {
                                                    boundary: 'viewport',
                                                    padding: 8,
                                                },
                                            },
                                            {
                                                name: 'offset',
                                                enabled: true,
                                                options: {
                                                    offset: [0, 4],
                                                },
                                            },
                                        ],
                                    }}

                                    slotProps={{
                                        popper: {
                                            sx: {
                                                zIndex: 1500,
                                            },
                                        },
                                    }}

                                    ListboxProps={{
                                        style: {
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            backgroundColor: '#fff',
                                            boxShadow: '0px 5px 15px rgba(0,0,0,0.2)'
                                        },
                                    }}

                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            name="transaction_type"
                                            label="Transaction Type"
                                            variant="outlined"
                                            size="small"
                                            value={taxInvoiceFormData.transaction_type}

                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        {taxInvoiceFormData.transaction_type !== "Regular" && (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={handleEyeClick} edge="end">
                                                                    <VisibilityIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}

                                    disabled={!taxInvoiceFormData.legal_name || isViewMode}

                                    value={
                                        transactionTypeOptions.find(
                                            (opt) => opt.transaction_type === taxInvoiceFormData.transaction_type
                                        ) || null
                                    }

                                    onChange={(e, newValue) => {
                                        handleChnageTaxInvoiceForm({
                                            target: {
                                                name: "transaction_type",
                                                value: newValue?.transaction_type || "Regular",
                                            },
                                        });
                                    }}

                                    sx={{
                                        '& .MuiInputBase-root': {
                                            fontSize: '1rem',
                                            height: 42,
                                            minHeight: 42,
                                        }
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3} mt={1}>

                                <SelectInput
                                    choice_id="igst_on_intra"
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                    choice_name="igst_on_intra"
                                    SelectLabel="IGST on Intra"
                                    name="igst_on_intra"
                                    value={taxInvoiceFormData.igst_on_intra}
                                    textOnchangeFunction={handleChnageTaxInvoiceForm}
                                    choices={
                                        taxInvoiceFormData.reverse_charge === "No"
                                            ? [
                                                { id: 2, igst_on_intra: "No" }
                                            ]
                                            : [
                                                { id: 1, igst_on_intra: "Yes" },
                                                { id: 2, igst_on_intra: "No" }
                                            ]
                                    }
                                    disabled={isViewMode}
                                />
                            </Grid>

                        </Grid>

                        <div style={tableContainerStyle}>

                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={tdThStyles}>Sl</TableCell>
                                        <TableCell style={tdThStyles}>HSN/SAC CODE</TableCell>
                                        <TableCell style={tdThStyles}>Quantity</TableCell>
                                        <TableCell style={tdThStyles}>Unit Price</TableCell>
                                        <TableCell style={tdThStyles}>Discount</TableCell>
                                        <TableCell style={tdThStyles}>Taxable Value</TableCell>
                                        <TableCell style={tdThStyles}>GST Rate</TableCell>
                                        <TableCell style={tdThStyles}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!taxInvoiceFormData?.tax_invoice_line_items || taxInvoiceFormData?.tax_invoice_line_items.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8} style={{ textAlign: 'center', padding: '24px', fontWeight: 'bold', color: '#888' }}>
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        taxInvoiceFormData?.tax_invoice_line_items && taxInvoiceFormData?.tax_invoice_line_items.map((item, index) => (
                                            <TableRow key={item.id} sx={rowHoverStyle}>
                                                {/* <TableCell style={cellStyles}>{item.sr_no}</TableCell> */}
                                                <TableCell style={cellStyles}>{index + 1}</TableCell>
                                                <TableCell style={cellStyles}>{item.hsn_sac_code}</TableCell>
                                                <TableCell style={cellStyles}>{parseFloat(item.quantity) + parseFloat(item?.free_quantity || 0)}</TableCell>
                                                <TableCell style={cellStyles}>{item.unit_price}</TableCell>
                                                <TableCell style={cellStyles}>{item.discount}</TableCell>
                                                <TableCell style={cellStyles}>{item.taxbale_value}</TableCell>
                                                <TableCell style={cellStyles}>{item.gst_rate}</TableCell>
                                                <TableCell style={cellStyles}>
                                                    <Tooltip title="View">
                                                        <IconButton size="small" color="primary" onClick={() => handleViewTaxInvoiceLineItem(item.sr_no)}>
                                                            <VisibilityIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Edit">
                                                        <IconButton size="small" color="warning" onClick={() => handleEditTaxInvoiceLineItem(item.sr_no)} disabled={isViewMode}>
                                                            <EditIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <IconButton size="small" color="error" onClick={() => handleDeleteTaxInvoiceLineItem(item.sr_no)} disabled={isViewMode}>
                                                            <DeleteIcon fontSize="medium" />
                                                        </IconButton>
                                                    </Tooltip>

                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        <div style={tableContainerStyle}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={tdThStyles}>Taxable Value</TableCell>
                                        <TableCell style={tdThStyles}>IGST</TableCell>
                                        <TableCell style={tdThStyles}>CGST</TableCell>
                                        <TableCell style={tdThStyles}>SGST</TableCell>
                                        <TableCell style={tdThStyles}>Cess AD</TableCell>
                                        <TableCell style={tdThStyles}>Cess Non-AD</TableCell>
                                        <TableCell style={tdThStyles}>State Cess</TableCell>
                                        <TableCell style={tdThStyles}>Total Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(!taxInvoiceFormData?.tax_invoice_line_items || taxInvoiceFormData.tax_invoice_line_items.length === 0) ? (
                                        <TableRow>
                                            <TableCell colSpan={8} style={{ textAlign: 'center', padding: '24px', fontWeight: 'bold', color: '#888' }}>
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                            {(() => {
                                                const totals = getTaxInvoiceLineItemTotals();
                                                return (
                                                    <>
                                                        <TableCell style={cellStyles}><strong>{totals.total_taxable_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_igst_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_cgst_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_sgst_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_cess_ad_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_cess_non_ad_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_state_cess_value.toFixed(2)}</strong></TableCell>
                                                        <TableCell style={cellStyles}><strong>{totals.total_item_amount.toFixed(2)}</strong></TableCell>
                                                    </>
                                                );
                                            })()}
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>



                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'flex-end' }}>
                                {/* Inputs in Column */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                                    <TextValidator
                                        name="other_charges"
                                        label="Other Charges"
                                        value={taxInvoiceFormData.other_charges}
                                        onChange={handleChnageTaxInvoiceForm}
                                        disabled={isViewMode}
                                        variant="outlined"
                                        size="small"
                                        validators={["matchRegexp:^[-]?[0-9]*\\.?[0-9]*$"]}
                                        errorMessages={["Invalid discount"]}
                                        sx={{ minWidth: 200 }}
                                    />

                                    <TextValidator
                                        name="discount"
                                        label="Discount"
                                        value={taxInvoiceFormData.discount}
                                        onChange={handleChnageTaxInvoiceForm}
                                        disabled={isViewMode}
                                        variant="outlined"
                                        size="small"
                                        validators={["matchRegexp:^[-]?[0-9]*\\.?[0-9]*$"]}
                                        errorMessages={["Invalid discount"]}
                                        sx={{ minWidth: 200 }}
                                    />

                                    <TextValidator
                                        name="round_off"
                                        label="Round Off"
                                        value={taxInvoiceFormData.round_off}
                                        onChange={handleChnageTaxInvoiceForm}
                                        variant="outlined"
                                        size="small"
                                        validators={["matchRegexp:^[-]?[0-9]*\\.?[0-9]*$"]}
                                        errorMessages={["Invalid round off value"]}
                                        sx={{ minWidth: 200 }}
                                        disabled={isViewMode}
                                    />

                                    <TextValidator
                                        name="grand_total"
                                        label="Grand Total"
                                        value={calculateGrandTotal()}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ minWidth: 200 }}
                                    />
                                </Box>

                                {/* Buttons in Column */}
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            color: 'text.secondary',
                                            borderColor: 'text.secondary',
                                            '&:hover': {
                                                backgroundColor: 'action.hover',
                                                borderColor: 'text.primary',
                                            },
                                        }}
                                        onClick={handleAttemptClose}
                                        endIcon={<CloseIcon />}
                                    >
                                        Close
                                    </Button>

                                    <Tooltip title={!isFormValid && tooltipTitle}>
                                        <span>
                                            <Button
                                                variant="contained"
                                                sx={{ color: 'white', borderColor: 'text.secondary' }}
                                                endIcon={<AddCircleOutlineIcon />}
                                                onClick={handleAddTaxInvoiceLineItem}
                                                disabled={!isFormValid || isViewMode}
                                            >
                                                Add Line Item
                                            </Button>
                                        </span>
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            (!taxInvoiceFormData?.tax_invoice_line_items || taxInvoiceFormData.tax_invoice_line_items.length === 0)
                                                ? "Please add Invoice with Line Item"
                                                : ""
                                        }
                                    >
                                        <span>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: 'primary.main',
                                                    px: 4,
                                                    '&:hover': {
                                                        backgroundColor: 'primary.dark',
                                                    },
                                                }}
                                                endIcon={<SaveIcon />}
                                                disabled={(!taxInvoiceFormData?.tax_invoice_line_items || taxInvoiceFormData.tax_invoice_line_items.length === 0) || isViewMode}
                                            >
                                                Submit
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>



                    </ValidatorForm>


                </Paper>
            </Slide>
        );
    }

    const AddressDialogContentForBillFromDispactchFrom = () => {

        return (
            <Container maxWidth="lg" sx={{ mt: 1, mb: 2 }}>

                <>
                    {(Array.isArray(dispatchFromOptions) && dispatchFromOptions.length === 0) &&
                        (Array.isArray(billToOptions) && billToOptions.length === 0) ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '300px', // adjust as needed
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <ValidatorForm onSubmit={handleSubmiDispatchFromAndBillTo} onError={(errors) => console.log(errors)}>

                            {(taxInvoiceFormData.transaction_type === "Bill From - Dispatch From" || taxInvoiceFormData.transaction_type === "Combination 2 & 3") && (
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="h6" fontWeight={550} gutterBottom>
                                            Dispatch From Details
                                        </Typography>
                                    </Grid>

                                    {/* Pincode */}
                                    <Grid item xs={12} sm={3} >
                                        <label>
                                            Pincode <span style={{ color: "red" }}>*</span>:
                                        </label>

                                        {Array.isArray(dispatchFromOptions) && dispatchFromOptions.length > 0 ? (
                                            <Autocomplete
                                                freeSolo
                                                options={dispatchFromOptions}
                                                getOptionLabel={(option) =>
                                                    typeof option === 'string'
                                                        ? option
                                                        : option.pincode?.toString() || ''
                                                }
                                                value={
                                                    dispatchFromOptions.find(
                                                        (opt) =>
                                                            opt.pincode?.toString() ===
                                                            taxInvoiceFormData.dispatch_pincode
                                                    ) || taxInvoiceFormData.dispatch_pincode || null
                                                }
                                                onChange={(e, newValue) => {
                                                    let newPincode = '';

                                                    if (typeof newValue === 'string') {
                                                        newPincode = newValue;
                                                    } else if (newValue && typeof newValue === 'object') {
                                                        newPincode = newValue.pincode?.toString() || '';
                                                    }

                                                    handleChnageTaxInvoiceForm({
                                                        target: {
                                                            name: 'dispatch_pincode',
                                                            value: newPincode,
                                                            newValue: newValue,
                                                        },
                                                    });
                                                }}
                                                onInputChange={(event, inputValue, reason) => {
                                                    if (reason === 'input') {
                                                        handleChnageTaxInvoiceForm({
                                                            target: {
                                                                name: 'dispatch_pincode',
                                                                value: inputValue,
                                                                newValue: null,
                                                            },
                                                        });
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextValidator
                                                        {...params}
                                                        label="Pincode *"
                                                        name="dispatch_pincode"
                                                        variant="outlined"
                                                        value={taxInvoiceFormData.dispatch_pincode}
                                                        size="small"
                                                        validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                                        errorMessages={[
                                                            'This field is required',
                                                            'Must be a 6-digit pincode',
                                                        ]}
                                                    />
                                                )}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontSize: '1rem',
                                                        height: 42,
                                                        minHeight: 42,
                                                    },
                                                }}
                                            />
                                            // <Autocomplete
                                            //     freeSolo
                                            //     options={dispatchFromOptions}
                                            //     getOptionLabel={(option) =>
                                            //         typeof option === 'string'
                                            //             ? option
                                            //             : option.supplier_pincode?.toString() || ''
                                            //     }
                                            //     value={
                                            //         dispatchFromOptions.find(
                                            //             (opt) =>
                                            //                 opt.supplier_pincode?.toString() ===
                                            //                 taxInvoiceFormData.dispatch_pincode
                                            //         ) || taxInvoiceFormData.dispatch_pincode || null
                                            //     }
                                            //     onChange={(e, newValue) => {
                                            //         let newPincode = '';

                                            //         if (typeof newValue === 'string') {
                                            //             // User typed a new pincode manually
                                            //             newPincode = newValue;
                                            //         } else if (newValue && typeof newValue === 'object') {
                                            //             newPincode = newValue.supplier_pincode?.toString() || '';
                                            //         }

                                            //         handleChnageTaxInvoiceForm({
                                            //             target: {
                                            //                 name: 'dispatch_pincode',
                                            //                 value: newPincode,
                                            //                 newValue: newValue,
                                            //             },
                                            //         });
                                            //     }}
                                            //     onInputChange={(event, inputValue, reason) => {
                                            //         if (reason === 'input') {
                                            //             // This ensures handleChange fires as user types a new value
                                            //             handleChnageTaxInvoiceForm({
                                            //                 target: {
                                            //                     name: 'dispatch_pincode',
                                            //                     value: inputValue,
                                            //                     newValue: null,
                                            //                 },
                                            //             });
                                            //         }
                                            //     }}
                                            //     renderInput={(params) => (
                                            //         <TextValidator
                                            //             {...params}
                                            //             label="Pincode *"
                                            //             name="dispatch_pincode"
                                            //             variant="outlined"
                                            //             value={taxInvoiceFormData.dispatch_pincode}
                                            //             size="small"
                                            //             validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                            //             errorMessages={[
                                            //                 'This field is required',
                                            //                 'Must be a 6-digit pincode',
                                            //             ]}
                                            //         />
                                            //     )}
                                            //     sx={{
                                            //         '& .MuiInputBase-root': {
                                            //             fontSize: '1rem',
                                            //             height: 42,
                                            //             minHeight: 42,
                                            //         },
                                            //     }}
                                            // />

                                        ) : (
                                            <>
                                                <label>
                                                    Pincode
                                                    <span style={{ color: "red" }}>*</span>:
                                                </label>
                                                <TextValidator
                                                    label="Pincode *"
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    name="dispatch_pincode"
                                                    value={taxInvoiceFormData.dispatch_pincode}
                                                    onChange={handleChnageTaxInvoiceForm}
                                                    inputProps={{ maxLength: 6 }}
                                                    onKeyPress={(e) => {
                                                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                                    }}
                                                    validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                                    errorMessages={["This field is required", "Must be a 6-digit pincode"]}
                                                />
                                            </>
                                        )}
                                    </Grid>

                                    {/* Legal Name */}
                                    <Grid item xs={12} sm={3}>
                                        <label>
                                            Legal Name
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Legal Name *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_legal_name"
                                            value={taxInvoiceFormData.dispatch_legal_name}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* {showGstinDispatch && ( */}
                                    <Grid item xs={12} sm={3}>
                                        <label>
                                            GSTIN
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="GSTIN *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_gstin"
                                            value={taxInvoiceFormData.dispatch_gstin}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>
                                    {/* )} */}



                                    {/* Location */}
                                    <Grid item xs={12} sm={3}>
                                        <label>
                                            Location
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Location *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_location"
                                            value={taxInvoiceFormData.dispatch_location}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* Address Line 1 */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            Primary Address
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Address Line 1 *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_address_1"
                                            value={taxInvoiceFormData.dispatch_address_1}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* Address Line 2 */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            Secondary Address
                                        </label>
                                        <TextValidator
                                            label="Address Line 2 *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_address_2"
                                            value={taxInvoiceFormData.dispatch_address_2}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* State */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            State
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="State*"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="dispatch_state"
                                            value={taxInvoiceFormData.dispatch_state}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {(taxInvoiceFormData.transaction_type === "Bill To - Ship To" || taxInvoiceFormData.transaction_type === "Combination 2 & 3") && (
                                <Grid container spacing={3} mt={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="h6" fontWeight={550} gutterBottom>
                                            Ship To Details
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={3} >
                                        <label>
                                            Pincode <span style={{ color: "red" }}>*</span>:
                                        </label>

                                        {Array.isArray(billToOptions) && billToOptions.length > 0 ? (
                                            <Autocomplete
                                                freeSolo
                                                options={billToOptions}
                                                getOptionLabel={(option) =>
                                                    typeof option === 'string'
                                                        ? option
                                                        : option.pincode?.toString() || ''
                                                }
                                                value={
                                                    billToOptions.find(
                                                        (opt) =>
                                                            opt.pincode?.toString() ===
                                                            taxInvoiceFormData.ship_pincode
                                                    ) || taxInvoiceFormData.ship_pincode || null
                                                }
                                                onChange={(e, newValue) => {
                                                    let newPincode = '';

                                                    if (typeof newValue === 'string') {
                                                        newPincode = newValue;
                                                    } else if (newValue && typeof newValue === 'object') {
                                                        newPincode = newValue.pincode?.toString() || '';
                                                    }

                                                    handleChnageTaxInvoiceForm({
                                                        target: {
                                                            name: 'ship_pincode',
                                                            value: newPincode,
                                                            newValue: newValue,
                                                        },
                                                    });
                                                }}
                                                onInputChange={(event, inputValue, reason) => {
                                                    if (reason === 'input') {
                                                        handleChnageTaxInvoiceForm({
                                                            target: {
                                                                name: 'ship_pincode',
                                                                value: inputValue,
                                                                newValue: null,
                                                            },
                                                        });
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextValidator
                                                        {...params}
                                                        label="Pincode *"
                                                        name="ship_pincode"
                                                        variant="outlined"
                                                        value={taxInvoiceFormData.ship_pincode}
                                                        size="small"
                                                        validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                                        errorMessages={[
                                                            'This field is required',
                                                            'Must be a 6-digit pincode',
                                                        ]}
                                                    />
                                                )}
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        fontSize: '1rem',
                                                        height: 42,
                                                        minHeight: 42,
                                                    },
                                                }}
                                            />

                                            // <Autocomplete
                                            //     freeSolo
                                            //     options={billToOptions}
                                            //     getOptionLabel={(option) =>
                                            //         typeof option === 'string'
                                            //             ? option
                                            //             : option.recipient_pincode?.toString() || ''
                                            //     }
                                            //     value={
                                            //         billToOptions.find(
                                            //             (opt) =>
                                            //                 opt.recipient_pincode?.toString() ===
                                            //                 taxInvoiceFormData.ship_pincode
                                            //         ) || taxInvoiceFormData.ship_pincode || null
                                            //     }
                                            //     onChange={(e, newValue) => {
                                            //         let newPincode = '';

                                            //         if (typeof newValue === 'string') {
                                            //             // User typed a new pincode manually
                                            //             newPincode = newValue;
                                            //         } else if (newValue && typeof newValue === 'object') {
                                            //             newPincode = newValue.recipient_pincode?.toString() || '';
                                            //         }

                                            //         handleChnageTaxInvoiceForm({
                                            //             target: {
                                            //                 name: 'ship_pincode',
                                            //                 value: newPincode,
                                            //                 newValue: newValue,
                                            //             },
                                            //         });
                                            //     }}
                                            //     onInputChange={(event, inputValue, reason) => {
                                            //         if (reason === 'input') {
                                            //             // This ensures handleChange fires as user types a new value
                                            //             handleChnageTaxInvoiceForm({
                                            //                 target: {
                                            //                     name: 'ship_pincode',
                                            //                     value: inputValue,
                                            //                     newValue: null,
                                            //                 },
                                            //             });
                                            //         }
                                            //     }}
                                            //     renderInput={(params) => (
                                            //         <TextValidator
                                            //             {...params}
                                            //             label="Pincode *"
                                            //             name="ship_pincode"
                                            //             variant="outlined"
                                            //             value={taxInvoiceFormData.ship_pincode}
                                            //             size="small"
                                            //             validators={['required', 'matchRegexp:^[0-9]{6}$']}
                                            //             errorMessages={[
                                            //                 'This field is required',
                                            //                 'Must be a 6-digit pincode',
                                            //             ]}
                                            //         />
                                            //     )}
                                            //     sx={{
                                            //         '& .MuiInputBase-root': {
                                            //             fontSize: '1rem',
                                            //             height: 42,
                                            //             minHeight: 42,
                                            //         },
                                            //     }}
                                            // />
                                        ) : (
                                            <>
                                                <label>
                                                    Pincode
                                                    <span style={{ color: "red" }}>*</span>:
                                                </label>
                                                <TextValidator
                                                    label="Pincode *"
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    name="ship_pincode"
                                                    value={taxInvoiceFormData.ship_pincode}
                                                    onChange={handleChnageTaxInvoiceForm}
                                                    inputProps={{ maxLength: 6 }}
                                                    onKeyPress={(e) => {
                                                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                                                    }}
                                                    validators={["required", "matchRegexp:^[0-9]{6}$"]}
                                                    errorMessages={["This field is required", "Must be a 6-digit pincode"]}
                                                />
                                            </>
                                        )}
                                    </Grid>

                                    {/* Legal Name */}
                                    <Grid item xs={12} sm={3} mt={3.5}>
                                        <TextValidator
                                            label="Legal Name *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_legal_name"
                                            value={taxInvoiceFormData.ship_legal_name}
                                            onChange={handleChnageTaxInvoiceForm}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />

                                    </Grid>

                                    {/* {showGstinBill && ( */}

                                    <Grid item xs={12} sm={3}>
                                        <label>
                                            GSTIN
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="GSTIN *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_gstin"
                                            value={taxInvoiceFormData.ship_gstin}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>
                                    {/* )} */}



                                    {/* Location */}
                                    <Grid item xs={12} sm={3}>
                                        <label>
                                            Location
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Location *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_location"
                                            value={taxInvoiceFormData.ship_location}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* Address Line 1 */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            Primary Address
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Address Line 1 *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_address_1"
                                            value={taxInvoiceFormData.ship_address_1}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* Address Line 2 */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            Secondary Address
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="Address Line 2 *"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_address_2"
                                            value={taxInvoiceFormData.ship_address_2}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>

                                    {/* State */}
                                    <Grid item xs={12} sm={4}>
                                        <label>
                                            State
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <TextValidator
                                            label="State*"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            name="ship_state"
                                            value={taxInvoiceFormData.ship_state}
                                            onChange={handleChnageTaxInvoiceForm}
                                            inputProps={{ maxLength: 100 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {/* Form Buttons */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        mr: 2,
                                        color: 'text.secondary',
                                        borderColor: 'text.secondary',
                                        '&:hover': {
                                            backgroundColor: 'action.hover',
                                            borderColor: 'text.primary',
                                        },
                                    }}
                                    onClick={cleaBillToShipToDetails}
                                >
                                    Clear
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                // loading={submitButtonLoading}
                                >
                                    Submit
                                </LoadingButton>
                            </Box>

                        </ValidatorForm>
                    )}
                </>

            </Container>
        );
    };


    const TaxInvoiceLineItemDailog = () => {
        const isViewMode = taxInvoiceLineAction === "view";
        const isEditMode = taxInvoiceLineAction === "edit"
        return (
            <Container maxWidth="lg" sx={{ mt: 1, mb: 2 }}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mb: 3
                }}>
                    <Description sx={{ mr: 2, color: 'primary.main' }} />
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                        {isEditMode ? 'Edit Tax Invoice Item' : (isViewMode ? 'View Tax Invoice Item' : 'Add Tax Invoice Item')}
                    </Typography>
                </Box>
                <ValidatorForm
                    onSubmit={handleSubmitTaxInvoiceLineItem}
                    onError={(errors) => console.log(errors)}
                >

                    <Grid container spacing={4}>



                        <Grid item xs={12} sm={2.99}>
                            <Autocomplete
                                options={productData}
                                getOptionLabel={(option) => option.product_description || ""}
                                renderInput={(params) => (
                                    <TextValidator
                                        {...params}
                                        name="product_description"
                                        label="Product Description *"
                                        variant="outlined"
                                        size="small"
                                        value={taxInvoiceLineItemFormData.product_description}
                                        validators={["required"]}
                                        errorMessages={["This field is required"]}
                                    />
                                )}
                                value={
                                    productData.find((opt) => opt.product_description === taxInvoiceLineItemFormData.product_description) || null
                                }
                                onChange={(e, newValue) => {
                                    if (!isViewMode) {
                                        handleChangeLineItem({
                                            target: {
                                                name: "product_description",
                                                value: newValue?.product_description || "",
                                                newValue: newValue
                                            },
                                        });
                                    }
                                }}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        fontSize: '1rem',
                                        height: 42,
                                        minHeight: 42,
                                    },
                                }}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                fullWidth={true}
                                size="small"
                                variant="outlined"
                                name="line_item_description"
                                label="Line Item Description"
                                value={taxInvoiceLineItemFormData.line_item_description}
                                onChange={handleChangeLineItem}
                                inputProps={{ maxLength: 100 }}
                                // validators={["required"]}
                                // errorMessages={["This field is required"]}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                fullWidth={true}
                                size="small"
                                variant="outlined"
                                name="is_service"
                                label="Is Service *"
                                value={taxInvoiceLineItemFormData.is_service}
                                onChange={handleChangeLineItem}
                                inputProps={{ maxLength: 100 }}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="hsn_sac_code"
                                label="HSN/SAC Code *"
                                value={taxInvoiceLineItemFormData.hsn_sac_code}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}

                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="unit"
                                label="Unit *"
                                value={taxInvoiceLineItemFormData.unit}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="quantity"
                                label="Quantity *"
                                value={taxInvoiceLineItemFormData.quantity}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                type="number"
                                inputProps={{

                                    step: "0.001"

                                }}
                                // onKeyPress={(e) => {
                                //     if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                //     if (e.key === '.' && e.target.value.includes('.')) {
                                //         e.preventDefault();
                                //     }
                                // }}
                                onKeyPress={(e) => {
                                    const { value } = e.target;
                                    if (value.includes('.')) {
                                        const decimalPart = value.split('.')[1];
                                        if (decimalPart && decimalPart.length >= 3) {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                validators={['required', 'isPositive', 'max3DecimalPlaces']}
                                errorMessages={[
                                    'Quantity is required',
                                    'Quantity must be greater than 0',
                                    'Max 3 decimal places allowed'
                                ]}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="unit_price"
                                label="Unit Price *"
                                value={taxInvoiceLineItemFormData.unit_price}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="free_quantity"
                                label="Free Qty"
                                value={taxInvoiceLineItemFormData.free_quantity}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="gross_amount"
                                label="Gross Amount *"
                                value={taxInvoiceLineItemFormData.gross_amount}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="discount"
                                label="Discount"
                                value={taxInvoiceLineItemFormData.discount}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="taxbale_value"
                                label="Taxable Value *"
                                value={taxInvoiceLineItemFormData.taxbale_value}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="gst_rate"
                                label="GST Rate *"
                                value={taxInvoiceLineItemFormData.gst_rate}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="cgst_value"
                                label="CGST Value"
                                value={taxInvoiceLineItemFormData.cgst_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="sgst_value"
                                label="SGST Value"
                                value={taxInvoiceLineItemFormData.sgst_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>



                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="igst_value"
                                label="IGST Value"
                                value={taxInvoiceLineItemFormData.igst_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="cess_rate"
                                label="Cess Rate (%)"
                                value={taxInvoiceLineItemFormData.cess_rate}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="cess_ad_value"
                                label="Cess Ad Value"
                                value={taxInvoiceLineItemFormData.cess_ad_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="cess_non_ad_value"
                                label="Cess Non-Ad Value"
                                value={taxInvoiceLineItemFormData.cess_non_ad_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="state_cess_rate"
                                label="State Cess Rate"
                                value={taxInvoiceLineItemFormData.state_cess_rate}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="state_cess_value"
                                label="State Cess Value"
                                value={taxInvoiceLineItemFormData.state_cess_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="state_cess_non_ad_value"
                                label="State Cess Non-Ad Value"
                                value={taxInvoiceLineItemFormData.state_cess_non_ad_value}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="other_charges"
                                label="Other Charges"
                                value={taxInvoiceLineItemFormData.other_charges}
                                onChange={handleChangeLineItem}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                disabled={isViewMode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2.99}>
                            <TextValidator
                                name="total_item_amount"
                                label="Total Item Amount *"
                                value={taxInvoiceLineItemFormData.total_item_amount}
                                onChange={handleChangeLineItem}
                                validators={["required"]}
                                errorMessages={["This field is required"]}
                                fullWidth
                                size="small"
                                variant="outlined"
                                onKeyPress={(e) => {
                                    if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                    if (e.key === '.' && e.target.value.includes('.')) {
                                        e.preventDefault();
                                    }
                                }}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>


                        <Button
                            variant="outlined"
                            sx={{
                                mr: 2,
                                color: 'text.secondary',
                                borderColor: 'text.secondary',
                                '&:hover': {
                                    backgroundColor: 'action.hover',
                                    borderColor: 'text.primary',
                                },
                            }}
                            onClick={() => {
                                setTaxInvoiceLineItemDailog(false);
                                clearTaxInvoiceLineItemData();
                            }}
                            endIcon={<CloseIcon />}
                        >
                            Close
                        </Button>


                        {!isViewMode &&
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: 'primary.main',
                                    px: 4,
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                                endIcon={<SaveIcon />}
                            >
                                {isEditMode ? "Save" : "Submit"}
                            </Button>
                        }

                    </Box>
                </ValidatorForm>
            </Container>
        )
    }


    const DiscardChangesDialog = () => {
        return (
            <Dialog
                open={showDiscardDialog}
                onClose={handleCancelClose}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-container': {
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    '& .MuiDialog-paper': {
                        margin: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <DialogContent>
                    <Typography>
                        You have unsaved changes. Are you sure you want to discard them?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCancelClose}
                        variant="outlined"
                        sx={{ color: 'text.secondary', borderColor: 'text.secondary' }}
                    >
                        Stay Here
                    </Button>
                    <Button
                        onClick={handleConfirmClose}
                        variant="contained"
                        sx={{
                            backgroundColor: '#00b0ff',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: '#0091ea'
                            }
                        }}
                        autoFocus
                    >
                        Discard
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };


    return (
        <div>

            {/* Main Table View */}

            {openTaxInvoiceForm && TaxInvoiceForm()}



            <Box sx={{ height: '65vh', width: '100%', marginTop: '0.8%' }}>
                <DataGridPro
                    rows={taxInvoiceData}
                    columns={columns}
                    loading={productDataLoading}
                    // apiRef={gridApiRef}
                    localeText={{
                        toolbarDensity: 'Size',
                        toolbarDensityLabel: 'Size',
                        toolbarDensityCompact: 'Small',
                        toolbarDensityStandard: 'Medium',
                        toolbarDensityComfortable: 'Large',
                    }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            // backgroundColor: '#1976d2',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },

                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        "& .MuiDataGrid-sortIcon": {
                            opacity: 'inherit !important',
                        },

                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeader': {
                                '& .MuiDataGrid-menuIconButton': {
                                    display: 'flex !important',
                                    visibility: 'visible !important',
                                    opacity: '1 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer'
                        },


                    }}
                    pagination
                    pageSize={5}
                    pageSizeOptions={[5, 10, 25, 50]}
                    components={{
                        Toolbar: CustomToolbar,
                        NoRowsOverlay: NoDataOverlay,
                        NoResultsOverlay: NoResultsOverlay
                    }}
                />

            </Box>

            <Dialog
                open={openAddressDialog}
                onClose={() => setOpenAddressDialog(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent dividers>
                    {AddressDialogContentForBillFromDispactchFrom()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenAddressDialog(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openTaxInvoiceLineItemDailog}
                onClose={() => {
                    setTaxInvoiceLineItemDailog(false)
                    clearTaxInvoiceLineItemData()
                }}
                maxWidth="lg"
                fullWidth
            >
                <DialogContent dividers>
                    {TaxInvoiceLineItemDailog()}
                </DialogContent>

            </Dialog>
            {DiscardChangesDialog()}

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default Taxinvoice; 